import { useEffect, memo } from "react";
import { useStoreDollHouseMap } from "../../store";
import { shallow } from "zustand/shallow";
import { resetAllMapPathSvg } from "../../components/customEvents";
import { __showDollHouseModal } from "../HotspotInfoModal";
import $ from "jquery";

function RoutePathElements({ routeResponse }) {
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      routeTypeSelected: state.routeTypeSelected,
      changePopupvisibility: state.changePopupvisibility,
      isSvgRoutePathVisibility: state.isSvgRoutePathVisibility,
    }),
    shallow
  );

  useEffect(() => {
    if (routeResponse) {
      resetAllMapPathSvg();

      let pathType = dollhouseStore.routeTypeSelected;

      if (pathType === "train") {
        if (document.getElementById(routeResponse[0].tram.svgid)) {
          showPath(routeResponse[0].tram.svgid);
        } else {
          dollhouseStore.changePopupvisibility(
            true,
            "Tram route is not the recommended route. Please consider the walking path."
          );
        }
      } else if (pathType === "walk") {
        if (document.getElementById(routeResponse[0].walk.svgid)) {
          showPath(routeResponse[0].walk.svgid);
        } else {
          dollhouseStore.changePopupvisibility(
            true,
            "Walk route currently unavailable."
          );
        }
      } else if (pathType === "bus") {
        dollhouseStore.changePopupvisibility(
          true,
          "Bus route currently unavailable."
        );
      } else {
        // console.log(routeResponse[0].walk.svgid);

        if (document.getElementById(routeResponse[0].walk.svgid)) {
          showPath(routeResponse[0].walk.svgid);
        }

        if (document.getElementById(routeResponse[0].tram.svgid)) {
          showPath(routeResponse[0].tram.svgid);
        }
      }
    }
  }, [routeResponse]);

  const showPath = (svgid) => {
    document.getElementById(svgid).classList.add("svg-tram-path-display");
  };

  useEffect(() => {
    $(".svg-path").on("mouseover", () => {
      handleMousEnter();
    });
  }, []);

  const handleMousEnter = () => {
    let timercheck = setTimeout(() => {
      console.log("movinf");
      __showDollHouseModal(false, 0, 0, "");
      clearTimeout(timercheck);
    }, 0);
  };

  return (
    <>
      <g transform="translate(497.405 1202.163)">
        <path
          className="svg-path"
          id="aria_e_conv_to_vdara_silk_road_walk"
          d="M5124.89,3964l54.94,14.013,37.771,70.392,24.036,15.452,118.465-15.452,94.429-25.753,156.236-20.6,108.164-24.036,80.693-29.187,49.79-10.3,25.753,39.488,48.073,85.844,116.748,84.127,111.6,70.392,106.446,42.922,223.195,65.242,123.615,27.47,163.1,15.452,164.821-42.922,120.182-82.411,87.561-108.163,48.073-104.73h29.187s53.226-73.825,42.924-68.674"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        <path
          className="svg-path"
          id="aria_w_convention_to_bellagio_convention_walk"
          d="M4929.036,3756.394l66.443,7.116,64.044,11.563,41.807,23.127,12.453,44.476,21.348,75.608,41.807,81.835,24.017,46.254,29.354,32.912,53.371-17.79,67.6-25.8,93.4-16.9,136.095-11.563h74.719l66.713-32.912,61.376-19.569,36.47-20.458h16.9l50.7,7.116,28.464,29.354,34.691,46.254,90.73,81.835,87.171,81.834,138.764,82.725,121.862,61.376,194.8,46.254,156.553,10.674,123.642-26.686,136.095-63.155,93.4-70.271,48.034-103.183,13.343-22.237,64.044-93.4,42.7-46.254,49.813-42.7,46.254-15.122,44.476-10.674h71.161l84.5,10.674,67.6,15.122,46.254,21.348,91.619,39.138,69.382,14.232,88.951-4.448h302.433l146.77-8.005,40.027-34.691,5.337-18.68,7.116-16.011,23.128-7.116h38.248l100.515,7.116,59.6-7.116V3477.088l155.664-8.006h562.169l100.515-30.243"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_e_convention_to_bellagio_convention_walk"
          d="M5197,4084l95.667-25.171,62.444-23.127,111.011-18.5,64.756-10.407,104.073-8.094,69.382-12.72,80.945-30.065,50.88-18.5,56.662-6.938,33.535,47.411,85.571,57.818,63.6,37,91.353,60.131,61.287,54.349S6356.52,4290.1,6391.21,4302.822s158.422,52.036,158.422,52.036l183.861,13.876s5.782,6.938,55.505,0,329.563-122.574,365.41-217.4,30.065-154.953,30.065-154.953l8.095-41.629,53.192-58.975,82.1-37,83.258-4.625,77.476,12.72,144.545,47.411,104.073,40.473,83.258,27.753h197.738L8249,3990h189l53-21s15-36,20-43,34-20,44-24,57,0,57,0,36-13,38-16-1-115,0-120-6-196-6-196V3465h747l70-14"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_e_convention_to_park_mgm_conference_walk"
          d="M5187.29,4044.161l50.89-7.675,58.986,200.09,15.036,82.118-105.25,54.359s-28.915,48.576-25.445,121.441,5.783,209.342,5.783,209.342,0,183.9-20.819,229-137.634,46.264-137.634,46.264l-203.559-17.349-211.655,11.566L4174.12,4750.1l-54.359-35.854-32.384-18.505-34.7-23.132-33.541-15.036-26.6,8.1s-28.915,31.228-31.228,34.7-31.228,56.673-31.228,56.673l-24.288,41.637"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_w_convention_to_park_mgm_conference_walk"
          d="M4935.636,3725.133l67.628,33.033,68.607,25.41,58.444,88.936,45.738,91.477L5247.2,4068.17l33.033,114.346L5303.1,4317.19l-68.607,45.738-33.331,22.845-13.879,45.107v296.086l-5.783,142.26-23.132,75.178s-45.107,24.288-48.577,24.288-112.188,12.723-112.188,12.723l-116.815-18.505h-84.431l-109.875,5.783h-84.431l-137.634-70.552-387.456-207.029s-67.082-69.4-114.5,12.723-56.673,91.37-56.673,91.37"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_w_convention_to_park_mgm_dolby_live_walk"
          d="M4935.636,3725.133l67.628,33.033,68.607,25.41,58.444,88.936,45.738,91.477L5247.2,4068.17l33.033,114.346L5303.1,4317.19l-68.607,45.738-33.331,22.845-13.879,45.107v296.086l-5.783,142.26-23.132,75.178s-45.107,24.288-48.577,24.288-112.188,12.723-112.188,12.723l-116.815-18.505h-84.431l-109.875,5.783h-84.431l-137.634-70.552-387.456-207.029s-67.082-69.4-114.5,12.723-56.673,91.37-56.673,91.37-28.147,25.5-112.325-50.464-277.17,333.289-277.17,333.289l-23.269,43.115s-64.331,65.7-67.068,69.122-36.271,34.218-36.271,34.218l-43.8,53.381-43.115,52.7-34.9,64.331-5.475,95.127v71.174l-4.106,176.568v183.411h-30.112"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_e_convention_to_park_mgm_dolby_live_walk"
          d="M5187.29,4044.161l50.89-7.675,58.986,200.09,15.036,82.118-105.25,54.359s-28.915,48.576-25.445,121.441,5.783,209.342,5.783,209.342,0,183.9-20.819,229-137.634,46.264-137.634,46.264l-203.559-17.349-211.655,11.566L4174.12,4750.1l-54.359-35.854-32.384-18.505-34.7-23.132-33.541-15.036-26.6,8.1s-28.915,31.228-31.228,34.7-31.228,56.673-31.228,56.673l-24.288,41.637-80.159-41.637-72.954-27.49-75.623,95.2-52.491,92.527-90.748,140.57-77.4,110.32s-90.747,88.079-95.2,91.638-88.079,95.2-88.079,95.2l-4.448,129v394.129l-5.338,44.484-52.491-4.449"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        <path
          className="svg-path"
          id="aria_e_conv_to_tclv_first_floor_walk"
          d="M5172.3,4068l174.6-32.668,130.694-20.819,75.178-12.722,128.381-25.445,28.915-11.566,68.238-16.192,65.926-11.566,46.263,11.566s23.132,91.37,47.42,113.345,152.669,71.708,152.669,71.708l114.5,76.335s182.741,72.865,186.21,72.865,75.178,40.481,86.744,42.794,188.523,42.793,188.523,42.793l171.175-12.722,90.214-30.071s100.623-62.456,102.936-65.925,102.937-126.068,102.937-126.068,71.708-204.716,71.708-208.186,72.865-60.142,72.865-60.142l196.62,45.107,168.862,102.936,32.384,198.933v69.4l23.132,348.132"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        <path
          className="svg-path"
          id="aria_w_conv_to_tclv_first_floor_walk"
          d="M7699.4,4629.817l-23.132-348.132v-69.4l-32.384-198.933L7475.021,3910.42l-196.62-45.107s-72.865,56.673-72.865,60.142-71.708,208.186-71.708,208.186-100.623,122.6-102.937,126.068-102.936,65.925-102.936,65.925l-90.214,30.071-171.175,12.722s-176.958-40.48-188.523-42.793-83.274-42.794-86.744-42.794-186.21-72.865-186.21-72.865l-114.5-76.335s-128.381-49.733-152.669-71.708-47.42-113.345-47.42-113.345l-46.263-11.566-65.926,11.566-68.238,16.192-28.915,11.566-128.381,25.445-75.178,12.722L5346.9,4035.332l-124.911,18.505-82.118-128.381-20.819-86.744-19.662-46.263-63.612-23.132h-62.456l-46.263-25.445"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        <path
          className="svg-path"
          id="aria_e_conv_to_tclv_third_floor_walk"
          d="M5172.3,4068l174.6-32.668,130.694-20.819,75.178-12.722,128.381-25.445,28.915-11.566,68.238-16.192,65.926-11.566,46.263,11.566s23.132,91.37,47.42,113.345,152.669,71.708,152.669,71.708l114.5,76.335s182.741,72.865,186.21,72.865,75.178,40.481,86.744,42.794,188.523,42.793,188.523,42.793l171.175-12.722,90.214-30.071s100.623-62.456,102.936-65.925,102.937-126.068,102.937-126.068,71.708-204.716,71.708-208.186,72.865-60.142,72.865-60.142l196.62,45.107,168.862,102.936,26.845,289.476h95.618v347.06l14.166,116.867-14.166,92.077v63.746l42.806,29.964,120.1,104.609-38.956,74.37-56.663,60.2-24.481,191.237"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30 30"
          opacity="0"
        />

        <path
          className="svg-path"
          id="aria_w_conv_to_tclv_third_floor_walk"
          d="M4927.06,3743.872l46.263,25.445h62.456l63.612,23.132,19.662,46.263,20.819,86.744,82.118,128.381,124.911-18.505,130.694-20.819,75.178-12.722,128.381-25.445,28.915-11.566,68.238-16.192,65.926-11.566,46.263,11.566s23.132,91.37,47.42,113.345,152.669,71.708,152.669,71.708l114.5,76.335s182.741,72.865,186.21,72.865,75.178,40.481,86.744,42.794,188.523,42.793,188.523,42.793l171.175-12.722,90.214-30.071s100.623-62.456,102.936-65.925,102.937-126.068,102.937-126.068,71.708-204.716,71.708-208.186,72.865-60.142,72.865-60.142l196.62,45.107,168.862,102.936,32.384,198.933v47.42s79.069,27.915,83,131.658c1.783,47.1,5.6,114.208,9.214,173.191,2.285,37.253,2.189,107.877,1.575,166.764-.241,23.083-.56,57.057-.845,88.272-.166,18.188-26.041,68.037.845,106.528,37.344,53.464,130.868,95.619,130.868,95.619l21.249,67.287-67.287,74.37-46.038,113.325v74.37"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        <path
          className="svg-path"
          id="aria_w_conv_to_tclv_cosmo_conventiona2_walk"
          d="M4927.06,3743.872l46.263,25.445h62.456l63.612,23.132,19.662,46.263,20.819,86.744,82.118,128.381h135.568l134.487-7.81,65.813-18.122,130.672-38.152,21.54-24.973,68.238-16.192,65.926-11.566,46.263,11.566s54.165,83.274,78.453,105.25,121.637,79.8,121.637,79.8l114.5,76.335s181.972,78.317,185.442,78.317,66.646,54.916,78.212,57.229c8.374,1.675,104.659,29.194,159.286,35.291,20.692,2.31,41.967,0,41.967,0h82.981l84.764-25.106,86.922-36.891s90.206-64.251,92.52-67.721,94.427-122.087,94.427-122.087,39.819-166.888,51.779-203.551c1.291-3.956,41.911-17.914,41.911-18.271,0-3.47,52.388-18.86,52.388-18.86s83.3,22.065,138.3,37.131,81.725,23.132,81.725,23.132l117.349,103.188,16.764,54.484v153.451l18.859,77.056s50.7,44.719,67.594,102.68,0,101.924,0,101.924l20.417,63.622,31.169,48.052-16.5,31.578-14.669,33.528-74.818,35.624v261.939l-69.772,71.248-99.089-12.573v217.934h44.605"
          transform="translate(41 -20)"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_e_conv_to_tclv_cosmo_conventiona2_walk"
          d="M5172.3,4068l174.6-32.668,130.694-20.819,75.178-12.722,128.381-25.445,28.915-11.566,68.238-16.192,65.926-11.566,46.263,11.566s23.132,91.37,47.42,113.345,152.669,71.708,152.669,71.708l114.5,76.335s182.741,72.865,186.21,72.865,75.178,40.481,86.744,42.794,188.523,42.793,188.523,42.793l171.175-12.722,90.214-30.071s100.623-62.456,102.936-65.925,102.937-126.068,102.937-126.068,71.708-204.716,71.708-208.186,72.865-60.142,72.865-60.142l196.62,45.107,168.862,102.936,32.384,198.933-15.056,47.42,64.961,122.017,10.478,224.22h41.914l38.577,57.347s-1.167,40.287-23.909,53.715-67.06,0-67.06,0l-39.814,16.764v62.866s2.1,98.49,0,104.776,0,85.916,0,85.916l-56.579,64.961-90.107,12.573-27.242,12.573v186.5h48.2"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        <path
          className="svg-path"
          id="aria_w_conv_to_tclv_third_floor_chelsea_walk"
          d="M4927.06,3743.872l46.263,25.445h62.456l63.612,23.132,19.662,46.263,20.819,86.744,82.118,128.381,124.911-18.505,130.694-20.819,75.178-12.722,128.381-25.445,28.915-11.566,68.238-16.192,65.926-11.566,46.263,11.566s23.132,91.37,47.42,113.345,152.669,71.708,152.669,71.708l114.5,76.335s182.741,72.865,186.21,72.865,75.178,40.481,86.744,42.794,188.523,42.793,188.523,42.793l171.175-12.722,90.214-30.071s100.623-62.456,102.936-65.925,102.937-126.068,102.937-126.068,71.708-204.716,71.708-208.186,72.865-60.142,72.865-60.142l196.62,45.107,168.862,102.936,32.384,198.933v69.4l23.132,348.132,82.1,36.933"
          transform="translate(41 -20)"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_e_conv_to_tclv_third_floor_chelsea_walk"
          d="M5172.3,4068l174.6-32.668,130.694-20.819,75.178-12.722,128.381-25.445,28.915-11.566,68.238-16.192,65.926-11.566,46.263,11.566s23.132,91.37,47.42,113.345,152.669,71.708,152.669,71.708l114.5,76.335s182.741,72.865,186.21,72.865,75.178,40.481,86.744,42.794,188.523,42.793,188.523,42.793l171.175-12.722,90.214-30.071s100.623-62.456,102.936-65.925,102.937-126.068,102.937-126.068,71.708-204.716,71.708-208.186,72.865-60.142,72.865-60.142l196.62,45.107,168.862,102.936,32.384,198.933v69.4l23.132,348.132,117.742,33.477"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_w_conv_to_tclv_second_floor_walk"
          d="M4927.06,3738.921l25.989,16.708,34.344,13.924h45.483l34.345,12.067,30.632,11.139,18.564,37.129,10.21,41.77,12.067,51.053,28.775,49.2s31.56,44.555,36.2,51.053,22.278,33.416,22.278,33.416l116.029-20.421,175.436-26.919,170.795-37.129,109.531-26.919,49.2-9.282,43.627,14.852,18.564,58.479,15.78,34.345,22.277,25.99,47.34,25.99,103.962,40.842,29.7,25.062,71.474,45.483,48.268,21.35,75.187,26.919,108.6,49.2,61.263,25.062,64.977,13.923,80.756,21.35h61.264l94.68-4.641,48.268-6.5,97.464-33.417,61.263-39.914,45.483-33.417,35.273-54.766,32.488-36.2,26.918-38.985,13.924-45.484,19.493-56.622,20.421-59.407,11.139-31.56,69.617-59.407,121.6,28.775,79.828,17.636,97.464,62.192,52.909,29.7,17.636,12.067,12.067,92.823,21.349,116.958,31.56,110.459,33.416,83.541"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_e_conv_to_tclv_second_floor_walk"
          d="M5177.958,4062.965l171.352-26.547L5544.8,4002.63l85.676-14.48,56.715-12.067,47.062-18.1,60.335-14.48,60.335-7.24,32.581,13.274,15.687,38.615,22.928,60.335,30.167,25.341,65.162,28.961,47.22,20.432,30.209,15.379s39.546,28.561,40.1,30.758,68.107,39.546,68.107,39.546l67.008,30.758,66.459,23.618,45.038,15.379,55.475,30.208,86.781,29.66,92.274,20.322,51.081,8.788,87.88-5.493,76.346-3.3,48.334-16.478,81.838-36.25,40.1-27.462,43.391-40.1,49.981-59.868,30.758-41.743,23.618-48.883,15.928-58.77,20.872-54.376L7207.807,3920l42.292-33.5,28.561-18.125,104.357,20.322,42.292,8.788,54.925,17.576s40.1,25.266,41.743,25.266,61.516,34.6,61.516,34.6l59.868,39.546,11.535,56.573,9.337,60.967,7.141,50.531,6.591,64.812,23.068,81.289,22.52,46.137,13.182,37.349,12.083,19.224"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_w_conv_to_vdara_rafael_walk"
          d="M4958.3,3751l76.188,21.555,60.976,18.558,37.116,90.138,29.163,82.185,58.325,95.44h119.3l98.092-34.465L5593.88,3997.9h106.045l108.7-58.325h50.372l42.418,71.581,114,76.883,95.44,79.534,124.6,74.231,74.232,42.418,132.556,47.72,211.339,32.612,170.795-9.282,91.9-41.771,121.6-58.479,72.4-71.474,49.2-96.536,39.914-156.872v-92.823L7298.7,3738l24.134-84.469V3435.393l47.346-101.175"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_e_conv_to_vdara_rafael_walk"
          d="M5197,4068l60.608-12.269,138.771-21.721,146.011-31.374,146.011-16.894,100.157-36.2,80.849-19.307,44.648,66.369s51.888,72.806,56.715,71.4,120.671,81.854,130.324,87.887S6229,4235.53,6229,4235.53l166.525,61.542s176.179,43.441,189.453,48.268,209.966,21.721,209.966,21.721l222.034-84.469s78.436-107.4,82.056-108.6,67.575-124.29,67.575-124.29l36.2-118.257s31.375-98.95,36.2-106.19,82.056-117.05,82.056-117.05l26.547-114.637-13.274-104.983-44.09-59.14s-5.07-19.435-5.07-20.7,29.575-18.167,29.575-18.167l32.859-10.562,20.8-23.66-7.181-44.779v-7.189"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="aria_w_conv_to_vdara_silk_road_walk"
          d="M4954.4,3700.028l64.118,58.142,83.854,33.033,50.82,152.461,55.9,109.264,50.82,17.787,92.772-30.641,106.753-27.064,79.689-7.518,129.307-7.518,84.2-40.6,54.128-13.714,39.093-13.35,34.582,13.35,33.078,69.346,70.667,76.682,139.832,28.568,192.456,127.8,245.081,96.228,190.953,27.064,172.91-43.6,88.71-54.128,130.81-145.846,52.625-144.342,7.518-114.271h64.653"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        <path
          className="svg-path"
          id="bellagio_convention_center_park_mgm_convention_tram"
          d="M8658.884,3492.915l-46.923,52.03H8430.377l9.252,255.606-189.681,28.915L8110,3882.669l-163.079,13.879-148.043,9.253-114.5,48.577-151.513,85.588-67.082,54.36-57.83,54.36-57.829,63.612-46.264,60.143-60.143,90.214-31.228,80.961-35.854,89.057-18.505,72.865-35.854,151.513-39.324,149.2-40.48,142.261-71.708,149.2-77.491,107.563-82.118,48.577-149.2,30.071-210.5,26.6-296.086,31.228-156.14,11.566H5801.45l-94.84-4.626-97.154-21.975L5505.363,5397.8l-101.78-45.107-96-47.42L5188.458,5240.5,5017.283,5134.1,4897,5061.233l-134.165-96-322.688-246.354-98.31-57.83-111.033-47.42-83.274-33.542-91.371-20.818-99.467,10.409-55.516,97.154-43.95,25.445-30.071,26.6-13.879,24.288,115.659,70.552"
          fill="none"
          stroke="#185BBF"
          strokeWidth="20"
          strokeDasharray="30 30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="bellagio_convention_center_park_mgm_dolby_live_tram"
          d="M8645.354,3492.915l-62.549,43.021h-130.96l-66.458,82.095v89.913l-56.685,93.823-168.1,58.639-123.142,37.138H7840.044L7738.4,3930.773l-207.191,107.5-144.643,132.915-60.594,72.321-72.321,119.233L7187.2,4503.481l-33.229,119.233-44.957,160.28-35.184,158.326-60.594,164.189-78.186,150.507-101.641,91.868-211.1,39.093-357.7,43-267.785,19.546-181.781,11.728-179.826-21.5-125.1-41.047-168.1-76.231-185.69-99.686-146.6-84.049-224.783-154.417L4657.9,4894.408,4409.658,4700.9l-148.552-87.959-173.962-39.093-119.233-25.41-84.049,80.14-117.278,101.641L3623.895,4912l-121.187,168.1-127.052,197.418-91.868,103.6-19.546,130.961,19.546,232.6v181.781h-48.866"
          fill="none"
          stroke="#185BBF"
          strokeWidth="20"
          strokeDasharray="30 30"
          opacity="0"
        />

        {/* <path
          className="svg-path"
          id="bellagio_convention_center_park_mgm_convention_tram"
          d="M8658.884,3492.915l-46.923,52.03H8430.377l9.252,255.606-189.681,28.915L8110,3882.669l-163.079,13.879-148.043,9.253-114.5,48.577-151.513,85.588-67.082,54.36-57.83,54.36-57.829,63.612-46.264,60.143-60.143,90.214-31.228,80.961-35.854,89.057-18.505,72.865-35.854,151.513-39.324,149.2-40.48,142.261-71.708,149.2-77.491,107.563-82.118,48.577-149.2,30.071-210.5,26.6-296.086,31.228-156.14,11.566H5801.45l-94.84-4.626-97.154-21.975L5505.363,5397.8l-101.78-45.107-96-47.42L5188.458,5240.5,5017.283,5134.1,4897,5061.233l-134.165-96-322.688-246.354-98.31-57.83-111.033-47.42-83.274-33.542-91.371-20.818-99.467,10.409-55.516,97.154-43.95,25.445-30.071,26.6-13.879,24.288,115.659,70.552"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30 30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="bellagio_convention_center_park_mgm_dolby_live_tram"
          d="M8645.354,3492.915l-62.549,43.021h-130.96l-66.458,82.095v89.913l-56.685,93.823-168.1,58.639-123.142,37.138H7840.044L7738.4,3930.773l-207.191,107.5-144.643,132.915-60.594,72.321-72.321,119.233L7187.2,4503.481l-33.229,119.233-44.957,160.28-35.184,158.326-60.594,164.189-78.186,150.507-101.641,91.868-211.1,39.093-357.7,43-267.785,19.546-181.781,11.728-179.826-21.5-125.1-41.047-168.1-76.231-185.69-99.686-146.6-84.049-224.783-154.417L4657.9,4894.408,4409.658,4700.9l-148.552-87.959-173.962-39.093-119.233-25.41-84.049,80.14-117.278,101.641L3623.895,4912l-121.187,168.1-127.052,197.418-91.868,103.6-19.546,130.961,19.546,232.6v181.781h-48.866"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30 30"
          opacity="0"
        /> */}

        <path
          className="svg-path"
          id="bellagio_convention_tcolv_levle1_walking"
          d="M8736.916,3464.216H8642.5l9.021,258.614L8642.5,3904.76H8516.2l-45.107,63.15h-55.632l-138.328,34.582L7970.4,4013.017l-218.017-10.525-76.682,27.064-10.525,193.96v402.956"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="bellagio_convention_tcolv_levle2_walking"
          d="M8736.916,3479.136H8636.482v424.121h-215.01l-57.136,27.064-25.561,69.164-64.653,24.057-221.024-6.014L7777.946,4007l-108.256,45.107-18.043,231.549,7.518,108.257,81.192,43.6,10.525,154.867s40.9,50.827,27.064,98.462-82.427,92.077-82.427,92.077V4940.29l-36.354,134.574H7504.282v251.441h56.663"
          fill="rgba(255,255,255,0)"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="bellagio_convention_tcolv_levle3_walking"
          d="M8758.5,3464.216l-111.493,6.014v105.25l6.015,106.753-6.015,105.25v114.271H8531.232L8474.1,3964.9h-57.135l-141.336,43.6H7719.307l-39.093,24.057-15.036,154.867v160.882l101.169,14.725v435.6l-28.332,70.829s28.332,49.581,109.784,99.16,38.4,177.071,38.4,177.071l-77.358,95.618V5368.8"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        {/* 
          <path
            className="svg-path"
            id="bellagio_convention_tcolv_levle1_walking"
            d="M8736.916,3464.216H8642.5l9.021,258.614L8642.5,3904.76H8516.2l-45.107,63.15h-55.632l-138.328,34.582L7970.4,4013.017l-218.017-10.525-76.682,27.064-10.525,193.96v402.956"
            fill="none"
            stroke="#000"
            strokeWidth="20"
            strokeDasharray="30"
            opacity="0"
          />
          <path
            className="svg-path"
            id="bellagio_convention_tcolv_levle2_walking"
            d="M8736.916,3479.136H8636.482v424.121h-215.01l-57.136,27.064-25.561,69.164-64.653,24.057-221.024-6.014L7777.946,4007l-108.256,45.107-18.043,231.549,7.518,108.257,81.192,43.6,10.525,154.867-81.192,186.442"
            fill="rgba(255,255,255,0)"
            stroke="#000"
            strokeWidth="20"
            strokeDasharray="30"
            opacity="0"
          />
          <path
            className="svg-path"
            id="bellagio_convention_tcolv_levle3_walking"
            d="M8758.5,3464.216l-111.493,6.014v105.25l6.015,106.753-6.015,105.25v114.271H8531.232L8474.1,3964.9h-57.135l-141.336,43.6H7719.307l-39.093,24.057-15.036,154.867v160.882l129.307,141.335"
            fill="none"
            stroke="#000"
            strokeWidth="20"
            strokeDasharray="30"
            opacity="0"
          /> */}
        <path
          className="svg-path"
          id="bellagio_convention_to_rafael_walking"
          d="M8784.129,3464.216H8664.9l-17.592,198.77v213.055l-156.37,37.138-33.229,66.458-166.144,19.546-181.781,11.728H7806.812L7601.575,3942.5l-170.053-37.138-84.049-29.32-80.14-48.866,35.184-107.505,44.957-115.323-44.957-121.187-27.365-56.684,27.365-27.365,44.957-17.592,27.365-86"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="bellagio_convention_to_silk_road_walking"
          d="M8793,3479H8662.944l-27.365,64.754v371.381l-111.414-21.5-44.957,21.5-9.772,50.82-70.367,9.773L8293.518,4007H8094.145l-263.875-9.773-164.189-43-127.051-27.365-158.326-43-134.87-13.683,9.773,56.685"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="park_mgm_conferance_to_vdara_silk_walking"
          d="M3938.5,4807.787l-24.718-23.439,43.6-69.164,37.589-42.1h43.6l66.157,33.079,88.71,49.618,102.243,52.007,151.86,81.811,99.235,49.618,46.611,25.561h320.259l72.171,15.036h76.682l57.136-15.036,40.6-25.561,18.043-49.618V4473.109l18.042-64.654,51.122-57.135,52.625-40.6-10.525-106.753s-27.064-79.689-27.064-84.2,15.036-63.15,15.036-63.15l115.774-36.086,150.356-19.546,126.3-16.539,111.264-31.575s49.618-19.546,57.136-19.546,58.639,19.546,58.639,19.546l76.682,91.718,237.563,169.9,126.3,63.15,293.2,73.675h222.528l139.832-64.653L7125.4,4152.85l46.61-57.135L7208.1,4005.5v-36.085"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="park_mgm_conferance_to_vdara_raphael_walking"
          d="M3938.5,4807.787l-24.718-23.439,43.6-69.164,37.589-42.1h43.6l66.157,33.079,88.71,49.618,102.243,52.007,151.86,81.811,99.235,49.618,46.611,25.561h320.259l72.171,15.036h76.682l57.136-15.036,40.6-25.561,18.043-49.618V4473.109l18.042-64.654,51.122-57.135,52.625-40.6-10.525-106.753s-27.064-79.689-27.064-84.2,15.036-63.15,15.036-63.15l115.774-36.086,150.356-19.546,126.3-16.539,111.264-31.575s49.618-19.546,57.136-19.546,58.639,19.546,58.639,19.546l76.682,91.718,237.563,169.9,126.3,63.15,293.2,73.675h222.528l139.832-64.653L7125.4,4152.85l46.61-57.135L7208.1,4005.5v-36.085l-4.857-53.2L7270.32,3791.3l58.986-130.695v-122.6l-31.228-121.442v-13.879l37.011-15.036,30.071-34.7,4.626-31.228v-11.566"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        <path
          className="svg-path"
          id="park_mgm_conferance_to_vdara_silk_tram"
          d="M3870.193,4781.1l-37.943-22.6-20.087-35.711,37.943-44.639,55.8-66.958,35.711-26.783,55.8-13.392,100.438-13.392,84.813,26.784,87.046,26.783,82.582,24.551,93.742,87.046,109.365,82.582,154,122.757,241.05,165.164,265.6,160.7,272.3,131.685,187.483,51.335,160.7,17.855h308.008l263.37-40.175,214.267-24.552,156.236-17.855,84.814-51.334,66.958-64.727,80.35-116.061,37.943-87.046,35.711-113.83,37.943-147.308,29.015-118.293,26.783-100.437,60.263-162.932,51.334-102.669,91.51-118.293,87.046-87.045,82.582-62.495,93.742-46.871,41.258-19.781,121.674-58.337,40.175-17.855h254.442l46.871-13.392L8251.5,3821.09,8385.418,3801l62.494,82.582,26.783,66.958-89.277,42.407H8088.569L7898.854,4017.5l-107.133-13.392-227.659-64.726-160.7-42.407-127.221-29.015h-60.262v82.582l22.319,22.625"
          fill="none"
          stroke="#185bbf"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        {/* 
        <path
          className="svg-path"
          id="park_mgm_conferance_to_vdara_silk_tram"
          d="M3839.493,4774l-27.951-52.771,68.608-91.477,73.69-58.443,132.133-15.246,261.726,73.689L4510.324,4774l282.054,216.579,254.1,162.626,188.036,111.805L5394.6,5351.4l266.808,88.936,261.726,15.246,254.1-15.246,175.331-20.328,238.857-22.869,175.331-27.951,86.4-40.657,96.559-96.559,99.1-182.954,50.821-180.413,38.115-177.872,40.656-157.544,50.821-142.3,83.854-137.215L7419.8,4134.252l162.625-132.134,73.962-33.737,70.877-32.33,119.428-40.656h276.972l119.428-78.772,132.134-17.787,48.279,50.821,48.28,109.264-109.265,43.2H8123.666l-276.972,10.164-363.367-99.1-170.249-53.362-47.381-24.57s33.542-98.31,33.542-101.78,37.011-121.442,37.011-121.442l-37.011-101.78-40.481-79.8L7289.985,3405,7327,3387.651l39.324-18.505,6.939-69.4"
          fill="none"
          stroke="#185BBF"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        /> */}
        <path
          className="svg-path"
          id="park_mgm_conferance_to_vdara_raphael_tram"
          d="M3839.493,4774l-27.951-52.771,68.608-91.477,73.69-58.443,132.133-15.246,261.726,73.689L4510.324,4774l282.054,216.579,254.1,162.626,188.036,111.805L5394.6,5351.4l266.808,88.936,261.726,15.246,254.1-15.246,175.331-20.328,238.857-22.869,175.331-27.951,86.4-40.657,96.559-96.559,99.1-182.954,50.821-180.413,38.115-177.872,40.656-157.544,50.821-142.3,83.854-137.215L7419.8,4134.252l162.625-132.134,73.962-33.737,70.877-32.33,119.428-40.656h276.972l119.428-78.772,132.134-17.787,48.279,50.821,48.28,109.264-109.265,43.2H8123.666l-276.972,10.164-363.367-99.1-170.249-53.362-20.97-5.584-12.488-3.325-2.32,4.131-10.248,18.246-7.282,12.966-1.574,2.8-.16.285v26.322l-35.185-6.538-9.581-32.85,18.478-32.85s20.531-25.322,21.215-27.375,17.109-26.69,17.109-26.69,30.8-39.694,32.166-43.115,30.8-75.281,30.8-75.281l8.9-52.7-8.9-36.956-40.926-62.962-22.036-45.853s-12.393-27.375-10.3-29.428-1.9-28.059,7.282-33.534,12.568-6.844,12.568-6.844l38.358-10.95,30.8-21.215,19.847-52.012-4.106-18.478"
          fill="none"
          stroke="#185BBF"
          strokeWidth="20"
          strokeDasharray="30 30"
          opacity="0"
        />

        <path
          className="svg-path"
          id="aria_w_convention_to_no_mad_walk"
          d="M4935.636,3725.133l67.628,33.033,68.607,25.41,58.444,88.936,45.738,91.477L5247.2,4068.17l33.033,114.346L5303.1,4317.19l-68.607,45.738-33.331,22.845-13.879,45.107v296.086l-5.783,142.26-23.132,75.178s-45.107,24.288-48.577,24.288-112.188,12.723-112.188,12.723l-116.815-18.505h-84.431l-109.875,5.783h-84.431l-137.634-70.552-387.456-207.029s-67.082-69.4-114.5,12.723-56.673,91.37-56.673,91.37l-140.5-81.337-78.118,120.525-26.005,28.669-56.577-67.857V4684.888l-22.32-4.5h-80.35v91.51"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="no_mad_to_vdara_raphael_tram"
          d="M7364.515,3300.037l4.106,18.478-19.847,52.012-30.8,21.215-38.358,10.95s-3.388,1.369-12.568,6.844-5.192,31.481-7.282,33.534,10.3,29.428,10.3,29.428l22.036,45.853,40.926,62.962,8.9,36.956-8.9,52.7s-29.428,71.859-30.8,75.281-32.166,43.115-32.166,43.115-16.425,24.637-17.109,26.69-21.215,27.375-21.215,27.375l-18.478,32.85,9.581,32.85,35.185,6.538v-26.322l.16-.285,1.574-2.8,7.282-12.966,10.248-18.246,2.32-4.131,12.488,3.325,20.97,5.584,170.249,53.362,363.367,99.1,276.972-10.164h238.856l109.265-43.2-48.28-109.264-48.279-50.821-132.134,17.787L8123.666,3895.4H7846.694l-119.428,40.656-70.877,32.33-73.962,33.737L7419.8,4134.252l-106.723,119.428L7229.224,4390.9l-50.821,142.3-40.656,157.544-38.115,177.872-50.821,180.413-99.1,182.954-96.559,96.559-86.4,40.657-175.331,27.951-238.857,22.869-175.331,20.328-254.1,15.246L5661.41,5440.34,5394.6,5351.4l-160.085-86.395L5046.481,5153.2l-254.1-162.626L4510.324,4774,4347.7,4629.752l-261.726-73.689-132.133,15.246-73.69,58.443-68.608,91.477-60.506,30.864-39.933,55.171-48.865,42.262-50.186-27.734-18.49-83.2v-62.072l-83.2,6.6v55.468h0"
          fill="none"
          stroke="#185bbf"
          strokeWidth="20"
          strokeDasharray="30 30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="no_mad_to_vdara_raphael_walking"
          d="M7369.787,3310.158v11.566l-4.626,31.228-30.071,34.7-37.011,15.036v13.879l31.228,121.442v122.6L7270.32,3791.3l-67.082,124.912,4.857,53.2V4005.5l-36.085,90.214-46.61,57.135-132.314,133.817-139.832,64.653H6630.727l-293.2-73.675-126.3-63.15-237.563-169.9-76.682-91.718s-51.122-19.546-58.639-19.546-57.136,19.546-57.136,19.546l-111.264,31.575-126.3,16.539-150.356,19.546-115.774,36.086s-15.036,58.639-15.036,63.15,27.064,84.2,27.064,84.2l10.525,106.753-52.625,40.6-51.122,57.135-18.042,64.654V4889.6l-18.043,49.618-40.6,25.561-57.136,15.036h-76.682l-72.171-15.036H4593.395l-46.611-25.561-99.235-49.618-151.86-81.811-102.243-52.007-88.71-49.618-66.157-33.079h-43.6l-37.589,42.1-43.6,69.164-30.678,15.417-61.736-44.543-61.736-34.384-89.087,146.134-59.391-49.232-8.6-107.061-9.378-37.593h-80.491l-8.6,62.6v48.664"
          fill="none"
          stroke="#000"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />
        <path
          className="svg-path"
          id="no_mad_bellagio_convention_center_tram"
          d="M3499.8,4744l5.078-48.328,64-14.377,33.14,25.4V4744l21.719,89.681,37.589,31.493,52.29-64.772,68.675-84.127,34.338-20.6,85.844-70.393,37.771-27.47,55.315-41.471,121.524,24.3,145.935,36.055L4393.5,4688.8l156.236,121.9,175.122,130.483,139.067,94.429,121.9,82.41,185.423,106.447,202.592,113.314,178.556,72.109,202.592,44.639,345.093-8.584,331.358-29.187,322.774-46.356,96.146-34.338L6919.034,5288l58.374-85.844,68.675-139.067,44.639-139.067,34.338-140.785,27.47-118.465,24.037-103.013,32.621-94.429,39.488-89.278,53.224-87.561,68.675-94.429,106.446-106.447,113.314-82.41,171.688-78.977,85.844-25.753,173.4-8.584,156.236-37.771,116.748-39.488,60.091-42.922,32.621-84.127v-65.241l34.337-66.958,78.977-25.753h87.562l77.26-32.621"
          fill="none"
          stroke="#185bbf"
          strokeWidth="20"
          strokeDasharray="30"
          opacity="0"
        />

        <g
          className="svg-path"
          id="nomad_to_dolby_live"
          data-name="nomad to dolby"
          transform="translate(463.237 710.408)"
          opacity="0"
        >
          <path
            id="Path_2129-2"
            data-name="Path 2129"
            d="M-7233.025-10888.354l-49.431,12.775-35.562,62.2-27.739,8.371-47.213-15.574-.02-.006-13.319,26.09-13.319,6.722-48.881-32.812,27.189-62.751"
            transform="translate(7471.54 11077.712)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2130"
            data-name="Path 2130"
            d="M-7473.592-10218.866h46.313v-203.911l-6.041-85.377,14.632-61.078,82.96-65.777,130.568-197.043,2-25.7-17.792-22.069"
            transform="translate(7473.592 11074.271)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-26"
            data-name="Group 3123"
            transform="translate(88.789)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -1049.43, -1912.57)"
              filter="url(#Union_1-38)"
            >
              <path
                id="Union_1-78"
                data-name="Union 1"
                d="M127.008,139.719H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H172.446l-22.719,25.4Z"
                transform="translate(1049.43 1912.57)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-38"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-38"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-38"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  3 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="dolby_live_to_t_mobile_walk"
          className="svg-path"
          opacity="0"
          transform="translate(0 493.659)"
        >
          <path
            id="Path_2109"
            data-name="Path 2109"
            d="M-7732.941-10511.624v19.082l2.987,45.244v24.17l-51.273,5.531H-7831.5l-127.711-2.543-19.635,10.066-47.789,20.63-64.326,10.563-73.451,17.589-49.78-72.4-17.588-90.487-13.552-107.634v-115.2l13.552-146.6,56.276-109.157,75.985-112,53.236-78.985,19.649-76.144-205.146-320.209"
            transform="translate(8245.337 11590.105)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3136-6"
            data-name="Group 3136"
            transform="translate(401.499 883.192)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -792.97, -2568.14)"
              filter="url(#Union_1-24)"
            >
              <path
                id="Union_1-48"
                data-name="Union 1"
                d="M196.822,139.77h52.122l-26.06,29.14ZM30,139.77a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H415.767a30,30,0,0,1,30,30V109.77a30,30,0,0,1-30,30Z"
                transform="translate(792.97 2568.14)"
                fill="#fff"
              />
            </g>

            <g
              id="Group_3119-24"
              data-name="Group 3119"
              transform="translate(115.693 35.282)"
            >
              <path
                id="walking-22"
                data-name="walking"
                d="M12.711,24.227l10.1-7.336a6.287,6.287,0,0,1,3.917-1.21,8.243,8.243,0,0,1,7.648,5.735,13.9,13.9,0,0,0,1.607,3.725,15.732,15.732,0,0,0,12.6,6.3v6.3a22.014,22.014,0,0,1-17.023-8.026l-2.2,12.463,6.495,5.452,7.005,19.248-5.924,2.155L30.51,51.372,19.827,42.407a6.3,6.3,0,0,1-2.247-6l1.6-9.091-2.133,1.55-6.7,9.227-5.1-3.706,7.409-10.2ZM31.25,14.105a6.3,6.3,0,1,1,4.457-1.846A6.3,6.3,0,0,1,31.25,14.105ZM21.885,55.642,11.756,67.712,6.929,63.662l9.378-11.174,2.351-6.87L24.3,50.345Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_5_mins._30_Sec."
                data-name="5 mins. 30 Sec."
                transform="translate(86.703 55.245)"
                fill="#1a1a1a"
                fontSize="46"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  6 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="nomad_to_t_mobile"
          className="svg-path"
          data-name="nomad to tmobile"
          transform="translate(52.275 469.617)"
          opacity="0"
        >
          <path
            id="Path_2131"
            data-name="Path 2131"
            d="M-8184.771-11685.191l144.408,326.715-9.728,114.036,89.159,14.981,171.962-5.971,69.628-44.2"
            transform="translate(8184.771 11685.191)"
            fill="none"
            stroke="#000"
            stroke-linecap="round"
            stroke-width="20"
            strokeDasharray="0 30"
          />

          {/* <path
            id="Path_2131-4"
            data-name="Path 2131"
            d="M-8184.772-11685.191l148.526,359.105-10,125.342,91.7,16.467,176.865-6.562,71.613-48.586"
            transform="translate(8184.772 11685.191)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          /> */}
          <g
            id="Group_3123-27"
            data-name="Group 3123"
            transform="translate(175.136 156.712)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -711.54, -1783.31)"
              filter="url(#Union_1-39)"
            >
              <path
                id="Union_1-79"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(711.54 1783.31)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-39"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-39"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-39"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  3 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_tmobile"
          className="svg-path"
          data-name="bellagio to tmobile"
          transform="translate(39.003 98.952)"
          opacity="0"
        >
          <path
            id="Path_2096-7"
            data-name="Path 2096"
            d="M-4457.431-12225.745l-42.576-5.082-4.369,15.171,4.369,78-4.369,75.777-3.971,91.9h-70.773l-23.115,13.662,4.369,30.9h-25.975l-57.825,21.13-56.318,5.561H-4789.3l-135.749,3.91-78.717-16.937-60.606-13.663-88.169-12.312-104.692-36.06-72.917-21.687h-41.86v61.4l3.461,39.257-25.495,35.046-23.17,43.239-22.948,32.768-37.8,34.278-42.361,25.794-46.491,19.594-54.484,14.325H-5693.7l-73.212-14.325-59.17-45.388-99.439-88.189-46.056-57.142-90.6,42.833-84.114,34.9-45.9,36.473-68.235-19.021h-79.4l-209.412,75.939-72.946,54.071v230l46.072,69.806-46.072,57.239-74.516-22.337h-291.958l-52.354-76.087-228.435-112.56-71.375,93.538-80.8-52.355-52.354,71.377-37.273-13.527-10.715-50.814-30.094-108.168-70.9-29.385-33.009,17.253,5.751,37.894v65.232l-55.855,32.931-71.613,48.585-176.865,6.562-91.7-16.466,10-125.343-148.526-359.1"
            transform="translate(8184.772 12230.827)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-7"
            data-name="Group 3123"
            transform="translate(1830.587 241.016)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-10)"
            >
              <path
                id="Union_1-49"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-10"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-10"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-10"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  21 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_tmobile1"
          className="svg-path"
          data-name="bellagio to tmobile"
          transform="translate(39.003 98.952)"
          opacity="0"
        >
          <path
            id="Path_2137"
            data-name="Path 2137"
            d="M-9302.584-11422.012l7.1-80.282-121.025,15.712-107.982,6.948h-79.855l-47.281,2.816-61.172,28.487L-9822.6-11387.9l-66.059,64.318-65.24,82.854-43.73,82.854-41.479,128.123-29.8,134.985-30.725,101.494-44.654,97.807-51.209,54.9-17.615,15.875-67.9,20.483-165.812,26.116-143.385,12.085-231.766,14.031-58.277-6.556-54.074-8.4-93.1-23.249-81.932-39.123-69.85-35.436-59.605-36.254-56.738-36.359-98.729-64.215-72.613-47.521-74.457-55.816-33.49-23.249-76.09,44.542"
            transform="translate(12818.822 11743.606)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />

          <g
            id="Group_3151"
            data-name="Group 3151"
            transform="translate(2055.034 998.001)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2591.44, -2299.12)"
              filter="url(#Union_1-11)"
            >
              <path
                id="Union_1-50"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2591.44 2299.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-11"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />
              <text
                id="_10_mins-11"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  17 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_dolby"
          className="svg-path"
          data-name="bellagio to dolby"
          transform="translate(463.237 98.952)"
          opacity="0"
        >
          <path
            id="Path_2096-6"
            data-name="Path 2096"
            d="M-4170.485-12225.745l-42.575-5.082-4.368,15.171,4.368,78-4.368,75.777-3.972,91.9h-70.773l-23.115,13.662,4.369,30.9h-25.974l-57.826,21.13-56.317,5.561h-51.312l-135.748,3.91-78.718-16.937-60.605-13.663-88.169-12.312-104.691-36.06-72.918-21.687h-41.861v61.4l3.463,39.257-25.494,35.046-23.17,43.239-22.949,32.768-37.795,34.278-42.361,25.794-46.49,19.594-54.484,14.325h-72.407l-73.213-14.325-59.169-45.388-99.439-88.189-46.055-57.142-90.6,42.833-84.114,34.9-45.9,36.473-68.234-19.021h-79.4l-209.414,75.939-72.945,54.071v230l46.071,69.806-46.071,57.239-74.517-22.337h-291.957l-52.354-76.087-228.435-112.56-71.375,93.538-80.8-52.355-52.353,71.377-148.7,230.88-82.96,65.776-14.632,61.079,6.041,85.377v203.91h-46.313"
            transform="translate(7473.592 12230.827)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-6"
            data-name="Group 3123"
            transform="translate(1406.353 241.016)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-8)"
            >
              <path
                id="Union_1-47"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-8"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-8"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-8"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  20 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_dolby1"
          className="svg-path"
          data-name="bellagio to dolby"
          transform="translate(463.237 98.952)"
          opacity="0"
        >
          <path
            id="Path_2136"
            data-name="Path 2136"
            d="M-9302.527-11421.59l7.039-80.7-121.025,15.712-107.982,6.948h-79.855l-47.281,2.816-61.172,28.487L-9822.6-11387.9l-66.059,64.318-65.24,82.854-43.73,82.854-41.479,128.123-29.8,134.985-30.725,101.494-44.654,97.807-51.209,54.9-17.615,15.875-67.9,20.483-165.812,26.116-143.385,12.085-231.766,14.031-58.277-6.556-54.074-8.4-93.1-23.249-81.932-39.123-69.85-35.436-59.605-36.254-56.738-36.359-98.729-64.215-72.613-47.521-74.457-55.816-33.49-23.249-76.09,44.542"
            transform="translate(12394.588 11743.606)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3150"
            data-name="Group 3150"
            transform="translate(1630.801 998.001)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2591.44, -2299.12)"
              filter="url(#Union_1-9)"
            >
              <path
                id="Union_1-48"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2591.44 2299.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-9"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />{" "}
              <text
                id="_10_mins-9"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  16 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_nomad"
          className="svg-path"
          data-name="bellagio to nomad"
          transform="translate(466.269 98.952)"
          opacity="0"
        >
          <path
            id="Path_2096-5"
            data-name="Path 2096"
            d="M-4168.434-12225.745l-42.575-5.082-4.369,15.171,4.369,78-4.369,75.777-3.972,91.9h-70.773l-23.115,13.662,4.369,30.9h-25.974l-57.826,21.13-56.318,5.561H-4500.3l-135.749,3.91-78.716-16.937-60.606-13.663-88.168-12.312-104.692-36.06-72.917-21.687h-41.861v61.4l3.461,39.257-25.493,35.046-23.17,43.239-22.949,32.768-37.794,34.278-42.362,25.794-46.49,19.594-54.484,14.325H-5404.7l-73.212-14.325-59.168-45.388-99.44-88.189-46.054-57.142-90.6,42.833-84.114,34.9-45.9,36.473-68.233-19.021h-79.4l-209.414,75.939-72.945,54.071v230l46.071,69.806-46.071,57.239-74.516-22.337h-291.958l-52.353-76.087-228.435-112.56-71.376,93.538-80.8-52.355-52.353,71.377-48.052-19.021-49.431,12.773-35.562,62.2-27.739,8.371-47.213-15.574-.02-.008-13.319,26.091-13.319,6.723-48.881-32.813,27.189-62.75"
            transform="translate(7468.508 12230.827)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-5"
            data-name="Group 3123"
            transform="translate(1403.321 241.016)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-6)"
            >
              <path
                id="Union_1-45"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-6"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-6"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-6"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  18 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_nomad1"
          className="svg-path"
          data-name="bellagio to nomad"
          transform="translate(466.269 98.952)"
          opacity="0"
        >
          <path
            id="Path_2135"
            data-name="Path 2135"
            d="M-9302.158-11421.962l6.67-80.332-121.025,15.712-107.982,6.948h-79.855l-47.281,2.816-61.172,28.487L-9822.6-11387.9l-66.059,64.318-65.24,82.854-43.73,82.854-41.479,128.123-29.8,134.985-30.725,101.494-44.654,97.807-51.209,54.9-17.615,15.875-67.9,20.483-165.812,26.116-143.385,12.085-231.766,14.031-58.277-6.556-54.074-8.4-93.1-23.249-81.932-39.123-69.85-35.436-59.605-36.254-56.738-36.359-98.729-64.215-72.613-47.521-74.457-55.816-33.49-23.249-76.09,44.542"
            transform="translate(12391.558 11743.606)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3149"
            data-name="Group 3149"
            transform="translate(1627.769 998.001)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2591.44, -2299.12)"
              filter="url(#Union_1-7)"
            >
              <path
                id="Union_1-46"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2591.44 2299.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-7"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />

              <text
                id="_10_mins-7"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  14 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_parkmgm"
          className="svg-path"
          data-name="bellagio to parkmgm"
          transform="translate(721.184 98.952)"
          opacity="0"
        >
          <path
            id="Path_2096-4"
            data-name="Path 2096"
            d="M-3996.012-12225.745l-42.576-5.082-4.369,15.171,4.369,78-4.369,75.777-3.971,91.9H-4117.7l-23.114,13.662,4.369,30.9h-25.975l-57.825,21.13-56.318,5.561h-51.312l-135.748,3.91-78.717-16.937-60.606-13.663-88.169-12.312-104.691-36.06-72.917-21.687h-41.861v61.4l3.461,39.257-25.493,35.046-23.17,43.239-22.949,32.768-37.795,34.278-42.36,25.794-46.491,19.594-54.483,14.325h-72.408l-73.212-14.325-59.17-45.388-99.438-88.189-46.056-57.142-90.6,42.833-84.114,34.9-45.9,36.473-68.235-19.021h-79.4l-209.413,75.939-72.946,54.071v230l46.071,69.806-46.071,57.239-74.516-22.337h-291.957l-52.354-76.087-228.436-112.56-71.374,93.538-80.8-52.355-52.354,71.377-28.619,41.185,47.467,14.309h9.6"
            transform="translate(7041.172 12230.827)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-4"
            data-name="Group 3123"
            transform="translate(1148.406 241.016)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-4)"
            >
              <path
                id="Union_1-43"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-4"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-4"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-4"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  17 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_parkmgm1"
          className="svg-path"
          data-name="bellagio to parkmgm"
          transform="translate(721.184 98.952)"
          opacity="0"
        >
          <path
            id="Path_2133"
            data-name="Path 2133"
            d="M-9302.531-11422.249l7.043-80.045-121.025,15.712-107.982,6.948h-79.855l-47.281,2.816-61.172,28.487L-9822.6-11387.9l-66.059,64.318-65.24,82.854-43.73,82.854-41.479,128.123-29.8,134.985-30.725,101.494-44.654,97.807-51.209,54.9-17.615,15.875-67.9,20.483-165.812,26.116-143.385,12.085-231.766,14.031-58.277-6.556-54.074-8.4-93.1-23.249-81.932-39.123-69.85-35.436-59.605-36.254-56.738-36.359-98.729-64.215-72.613-47.521-74.457-55.816-33.49-23.249-76.09,44.542"
            transform="translate(12136.642 11743.606)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />

          <g
            id="Group_3148"
            data-name="Group 3148"
            transform="translate(1372.853 998.001)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2591.44, -2299.12)"
              filter="url(#Union_1-5)"
            >
              <path
                id="Union_1-44"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2591.44 2299.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-5"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />{" "}
              <text
                id="_10_mins-5"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  13 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_cosmos"
          className="svg-path"
          data-name="bellagio to cosmos"
          transform="translate(3128.28 98.952)"
          opacity="0"
        >
          <path
            id="Path_2096-3"
            data-name="Path 2096"
            d="M-2367.885-12225.745l-42.575-5.082-4.369,15.171,4.369,78-4.369,75.777-3.971,91.9h-70.774l-23.114,13.662,4.369,30.9h-25.974l-57.826,21.13-56.318,5.561h-51.312l-135.749,3.91-78.717-16.937-70.927,16.938-20.807,38.689v84.167l20.807,74.906,23.223,40.272,10.874,29.4v56.11l20.807,35.307s-9.8,362.58-12.216,369.829-8.591,48.863-8.591,48.863l-10.874,134.238"
            transform="translate(3005.949 12230.827)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-3"
            data-name="Group 3123"
            transform="translate(126.432 149.152)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -3752.12, -1450.27)"
              filter="url(#Union_1-3)"
            >
              <path
                id="Union_1-42"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(3752.12 1450.27)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-3"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-3"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-3"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  4 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_vdara"
          className="svg-path"
          data-name="bellagio to vdara"
          transform="translate(2893.63 0)"
          opacity="0"
        >
          <path
            id="Path_2096-2"
            data-name="Path 2096"
            d="M-2526.6-12292.674l-42.576-5.083-4.369,15.172,4.369,78-4.369,75.777-3.971,91.9h-70.773l-23.115,13.661,4.369,30.9h-25.975l-57.826,21.13-56.318,5.561h-51.312l-135.749,3.909-78.717-16.937-60.606-13.662-88.169-12.312-104.691-36.061-72.918-21.685,19.4-66.406,19.021-53.776v-50.782l-19.021-64.392-11.169-30.893,38.044-14.135,15.88-28.621v-25.3"
            transform="translate(3399.313 12396.709)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-2"
            data-name="Group 3123"
            transform="translate(130.229 200.978)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -3521.26, -1403.14)"
              filter="url(#Union_1-2)"
            >
              <path
                id="Union_1-41"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(3521.26 1403.14)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-2"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-2"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-2"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  5 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="bellagio_to_aria"
          className="svg-path"
          data-name="bellagio to aria"
          transform="translate(2123.644 98.952)"
          opacity="0"
        >
          <path
            id="Path_2096"
            data-name="Path 2096"
            d="M-4690.107-11909.956l37.586,25.3,90.973-10.158,46.055,57.142,99.44,88.189,59.168,45.388,73.212,14.325h72.408l54.484-14.325,46.491-19.594,42.361-25.794,37.8-34.278,22.948-32.768,23.17-43.239,25.494-35.046-3.461-39.257v-61.4h41.861l72.918,21.687,104.69,36.06,88.169,12.312,60.606,13.663,78.717,16.938,135.749-3.91h51.313l56.318-5.561,57.826-21.13h25.974l-4.369-30.9,23.115-13.662h70.773l3.971-91.9,4.369-75.777-4.369-78,4.369-15.171,42.576,5.082"
            transform="translate(4690.107 12230.827)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123"
            data-name="Group 3123"
            transform="translate(873.967 67.428)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -3495.02, -1368.54)"
              filter="url(#Union_1)"
            >
              <path
                id="Union_1-40"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(3495.02 1368.54)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  10 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        {/* <g id="dolby_live_to_t_mobile_walk" className="svg-path" opacity="0">
        <path
          id="Path_2109"
          data-name="Path 2109"
          d="M-7386.685-9782.827v31.977l5,75.818v40.5l-85.92,9.269h-84.253l-214.013-4.263-32.9,16.869-80.082,34.572-107.795,17.7-123.088,29.475-83.418-121.326-29.475-151.637-22.709-180.368v-193.043l22.709-245.663,94.306-182.923,127.332-187.689,89.211-132.36,32.926-127.6-343.776-536.594"
          transform="translate(9084 14412)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeWidth="30"
          strokeDasharray="0 45"
        />
        <g
          id="Group_3136-6"
          data-name="Group 3136"
          transform="translate(1578.705 4303.158)"
        >
          <g
            transform="matrix(1, 0, 0, 1, -1578.71, -4303.16)"
            filter="url(#Union_1-24)"
          >
            <path
              id="Union_1-48"
              data-name="Union 1"
              d="M79.828,234.653h87.343L123.5,283.486Zm-299.828,0a30,30,0,0,1-30-30V30.432a30,30,0,0,1,30-30H467a30,30,0,0,1,30,30V204.654a30,30,0,0,1-30,30Z"
              transform="translate(1578.82 4303.16)"
              fill="#fff"
            />
          </g>
          <g
            id="Group_3119-24"
            data-name="Group 3119"
            transform="translate(-213.395 54.555)"
          >
            <path
              id="walking-22"
              data-name="walking"
              d="M17.754,39.585,34.679,27.291a10.535,10.535,0,0,1,6.564-2.028,13.814,13.814,0,0,1,12.817,9.611,23.3,23.3,0,0,0,2.693,6.242A26.363,26.363,0,0,0,77.865,51.668V62.229a36.89,36.89,0,0,1-28.527-13.45L45.658,69.665,56.541,78.8l11.739,32.255-9.928,3.612L47.58,85.074,29.678,70.05A10.561,10.561,0,0,1,25.913,60L28.6,44.76l-3.575,2.6L13.793,62.821,5.249,56.61,17.664,39.522ZM48.821,22.623a10.562,10.562,0,1,1,7.468-3.093A10.562,10.562,0,0,1,48.821,22.623ZM33.126,92.23,16.154,112.455l-8.09-6.786L23.779,86.943l3.939-11.512,9.458,7.921Z"
              transform="translate(19.751 3.5)"
              fill="#1a1a1a"
            />
            <text
              id="_5_mins._30_Sec."
              data-name="5 mins. 30 Sec."
              transform="translate(120.021 100.168)"
              fill="#1a1a1a"
              fontSize="80"
              fontFamily="TradeGothicLTStd-Bold, Trade Gothic LT Std"
              fontWeight="700"
            >
              <tspan x="0" y="0">
                5 Mins. 30 Sec.
              </tspan>
            </text>
          </g>
        </g>
      </g> */}

        <path
          id="path_1"
          d="M4714.532,4940.309l98.878,68.725,148.316,100.8,97.728,61.852,124.171,74.453,182.809,98.506,187.407,73.307,137.968,28.636,197.755,11.454,165.562-11.454,128.771-8.018,203.5-20.618-9.2-144.322"
          transform="translate(9.285 3.655)"
          fill="rgba(197,2,2,0)"
          opacity="0.01"
        />
        <path
          id="path_2"
          d="M4705.225,5007.812,5088,5224.162l302.587,125.574s90.776,34.8,51.44-62.03-51.44-151.293-51.44-151.293,12.1-184.578,143.729-231.479,232.992,9.078,232.992,9.078,111.957,51.44,105.905,201.22-99.854,193.656-99.854,193.656l-68.082,65.056s-107.418,110.444,428.16,0c214.837-84.725,213.324-95.315,213.324-95.315"
          fill="rgba(87,239,33,0)"
          opacity="0"
        />
        <path
          id="path_3"
          d="M4752.13,4873.166l110.444,110.444,78.673,65.056,107.418,66.569,122.548,74.134s60.518,31.772,86.237-21.181,45.388-128.6,45.388-128.6l43.875-99.854,55.979-66.569,102.879-54.466s125.574-36.31,189.117-22.694,167.936,77.16,167.936,77.16,69.6,62.03,84.725,93.8,22.694,116.5,22.694,116.5l-6.052,119.522-6.052,74.134,12.1,34.8,80.186,22.694,198.195-45.388,84.724-27.233"
          fill="rgba(255,255,255,0)"
          opacity="0"
        />
        <rect
          id="walk_path"
          width="215"
          height="75"
          transform="translate(4853 4869)"
          fill="rgba(255,255,255,0)"
        />
        <rect
          id="train_path"
          width="215"
          height="75"
          transform="translate(5800 5479)"
          fill="rgba(255,255,255,0)"
        />
        <rect
          id="bus_path"
          width="215"
          height="75"
          transform="translate(5418 5101)"
          fill="rgba(255,255,255,0)"
        />
        <rect
          id="aria_title"
          width="414"
          height="247"
          transform="translate(4999 3398)"
          fill="rgba(223,23,23,0)"
        />

        <g
          className="path_info_popup"
          id="aria_e_convention_to_bellagio_convention_walk_info"
          transform="translate(1562.596 -1703.12)"
          opacity="0"
        >
          <path
            id="Path_8"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_8_Mins"
            data-name="8 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-71.211" y="0">
              8 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_w_convention_to_bellagio_convention_walk_info"
          transform="translate(1450 -1800)"
          opacity="0"
        >
          <path
            id="Path_8-2"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-2"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-2"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_10_Mins"
            data-name="10 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-80.667" y="0">
              10 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_e_convention_to_park_mgm_conference_walk_info"
          transform="translate(210 -880.167)"
          opacity="0"
        >
          <path
            id="Path_8-3"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-3"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-3"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_8_Mins-2"
            data-name="8 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-71.211" y="0">
              8 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_w_convention_to_park_mgm_conference_walk_info"
          transform="translate(210 -880.167)"
          opacity="0"
        >
          <path
            id="Path_8-4"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-4"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-4"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_8_Mins-3"
            data-name="8 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-71.211" y="0">
              8 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_e_convention_to_park_mgm_dolby_live_walk_info"
          transform="translate(-149.404 -944.56)"
          opacity="0"
        >
          <path
            id="Path_8-5"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-5"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-5"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_11_Mins"
            data-name="11 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-77.075" y="0">
              11 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_w_convention_to_park_mgm_dolby_live_walk_info"
          transform="translate(-452.211 -1088.743)"
          opacity="0"
        >
          <path
            id="Path_8-6"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-6"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-6"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_11_Mins-2"
            data-name="11 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-77.075" y="0">
              11 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_e_conv_to_tclv_first_floor_walk_info"
          transform="translate(1960.596 -1474.543)"
          opacity="0"
        >
          <path
            id="Path_8-7"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-7"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-7"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_11_Mins-3"
            data-name="11 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-77.075" y="0">
              11 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_w_conv_to_tclv_first_floor_walk_info"
          transform="translate(1960.596 -1474.543)"
          opacity="0"
        >
          <path
            id="Path_8-8"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-8"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-8"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_11_Mins-4"
            data-name="11 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-77.075" y="0">
              11 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_w_conv_to_tclv_second_floor_walk_info"
          transform="translate(1960.596 -1474.543)"
          opacity="0"
        >
          <path
            id="Path_8-9"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-9"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-9"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_11_Mins-5"
            data-name="11 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-77.075" y="0">
              11 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_e_conv_to_tclv_second_floor_walk_info"
          transform="translate(1960.596 -1474.543)"
          opacity="0"
        >
          <path
            id="Path_8-10"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-10"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-10"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_11_Mins-6"
            data-name="11 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-77.075" y="0">
              11 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_w_conv_to_tclv_cosmo_conventiona2_walk_info"
          transform="translate(1450 -1800)"
          opacity="0"
        >
          <path
            id="Path_8-11"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-11"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-11"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_14_Mins"
            data-name="14 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-81.16" y="0">
              14 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_e_conv_to_tclv_cosmo_conventiona2_walk_info"
          transform="translate(1941.692 -1461.996)"
          opacity="0"
        >
          <path
            id="Path_8-12"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-12"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-12"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_14_Mins-2"
            data-name="14 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-81.16" y="0">
              14 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_e_conv_to_tclv_third_floor_walk_info"
          transform="translate(1960.596 -1474.543)"
          opacity="0"
        >
          <path
            id="Path_8-13"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-13"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-13"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_11_Mins-7"
            data-name="11 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-77.075" y="0">
              11 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_w_conv_to_tclv_third_floor_walk_info"
          transform="translate(1960.596 -1474.543)"
          opacity="0"
        >
          <path
            id="Path_8-14"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-14"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-14"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_11_Mins-8"
            data-name="11 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-77.075" y="0">
              11 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_e_conv_to_vdara_rafael_walk_info"
          transform="translate(1960.596 -1485.5)"
          opacity="0"
        >
          <path
            id="Path_8-15"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-15"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-15"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_7_Mins"
            data-name="7 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-70.764" y="0">
              7 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_w_conv_to_vdara_rafael_walk_info"
          transform="translate(1450 -1800)"
          opacity="0"
        >
          <path
            id="Path_8-16"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-16"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-16"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_7_Mins-2"
            data-name="7 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-70.764" y="0">
              7 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_w_conv_to_vdara_silk_road_walk_info"
          transform="translate(1450 -1800)"
          opacity="0"
        >
          <path
            id="Path_8-17"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-17"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-17"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_7_Mins-3"
            data-name="7 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-70.764" y="0">
              7 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_e_conv_to_vdara_silk_road_walk_info"
          transform="translate(1206.548 -1897.62)"
          opacity="0"
        >
          <path
            id="Path_8-18"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-18"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-18"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_7_Mins-4"
            data-name="7 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-70.764" y="0">
              7 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="bellagio_convention_center_park_mgm_convention_tram_info"
          transform="translate(1646.134 -398.616)"
          opacity="0.06"
        >
          <path
            id="Path_8-19"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.329) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-19"
            data-name="Rectangle 5"
            width="302.81"
            height="109.309"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="Path_563"
            data-name="Path 563"
            d="M95.675,31.565,93.907,13.3a7.922,7.922,0,0,0-7.621-7.44H81.88V3.512h1.658a1.174,1.174,0,0,1,.985.557,1.536,1.536,0,0,0,2.2.369,1.849,1.849,0,0,0,.468-2.355A4.346,4.346,0,0,0,83.535,0H70.829a4.349,4.349,0,0,0-3.651,2.081,1.85,1.85,0,0,0,.414,2.442,1.542,1.542,0,0,0,2.252-.449,1.174,1.174,0,0,1,.985-.557h1.658V5.868H68.075a7.923,7.923,0,0,0-7.621,7.444L58.686,31.6a8.993,8.993,0,0,0,.218,3.008L60.672,41.8a8.016,8.016,0,0,0,5.389,5.874L64.239,53.3a1.8,1.8,0,0,0,.992,2.239A1.591,1.591,0,0,0,67.3,54.465l2.1-6.5H84.959l2.1,6.5a1.591,1.591,0,0,0,2.064,1.075,1.8,1.8,0,0,0,.992-2.239L88.3,47.67a8.018,8.018,0,0,0,5.389-5.885l1.768-7.218A8.974,8.974,0,0,0,95.675,31.565ZM75.722,3.512h2.915V5.863H75.722ZM72.227,40.625a.743.743,0,0,1-.711.771H66.425a.728.728,0,0,1-.7-.62l-.57-3.114a.819.819,0,0,1,.148-.64.69.69,0,0,1,.55-.281h5.658a.743.743,0,0,1,.711.771v3.114Zm16.979-2.963-.57,3.114a.731.731,0,0,1-.7.621H82.848a.743.743,0,0,1-.711-.771V37.508a.743.743,0,0,1,.711-.771h5.658a.691.691,0,0,1,.55.281.819.819,0,0,1,.148.64Zm-25.5-8.612L64.76,18.2a5.882,5.882,0,0,1,5.658-5.526H83.933A5.882,5.882,0,0,1,89.591,18.2l1.052,10.852H63.7Z"
            transform="translate(4597.048 5676.834)"
          />
          <text
            id="_13_Mins"
            data-name="13 Mins"
            transform="translate(4794.923 5720.474)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-80.667" y="0">
              13 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="bellagio_convention_center_park_mgm_dolby_live_tram_info"
          transform="translate(1646.134 -398.616)"
          opacity="0"
        >
          <path
            id="Path_8-20"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.329) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-20"
            data-name="Rectangle 5"
            width="302.81"
            height="109.309"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="Path_563-2"
            data-name="Path 563"
            d="M95.675,31.565,93.907,13.3a7.922,7.922,0,0,0-7.621-7.44H81.88V3.512h1.658a1.174,1.174,0,0,1,.985.557,1.536,1.536,0,0,0,2.2.369,1.849,1.849,0,0,0,.468-2.355A4.346,4.346,0,0,0,83.535,0H70.829a4.349,4.349,0,0,0-3.651,2.081,1.85,1.85,0,0,0,.414,2.442,1.542,1.542,0,0,0,2.252-.449,1.174,1.174,0,0,1,.985-.557h1.658V5.868H68.075a7.923,7.923,0,0,0-7.621,7.444L58.686,31.6a8.993,8.993,0,0,0,.218,3.008L60.672,41.8a8.016,8.016,0,0,0,5.389,5.874L64.239,53.3a1.8,1.8,0,0,0,.992,2.239A1.591,1.591,0,0,0,67.3,54.465l2.1-6.5H84.959l2.1,6.5a1.591,1.591,0,0,0,2.064,1.075,1.8,1.8,0,0,0,.992-2.239L88.3,47.67a8.018,8.018,0,0,0,5.389-5.885l1.768-7.218A8.974,8.974,0,0,0,95.675,31.565ZM75.722,3.512h2.915V5.863H75.722ZM72.227,40.625a.743.743,0,0,1-.711.771H66.425a.728.728,0,0,1-.7-.62l-.57-3.114a.819.819,0,0,1,.148-.64.69.69,0,0,1,.55-.281h5.658a.743.743,0,0,1,.711.771v3.114Zm16.979-2.963-.57,3.114a.731.731,0,0,1-.7.621H82.848a.743.743,0,0,1-.711-.771V37.508a.743.743,0,0,1,.711-.771h5.658a.691.691,0,0,1,.55.281.819.819,0,0,1,.148.64Zm-25.5-8.612L64.76,18.2a5.882,5.882,0,0,1,5.658-5.526H83.933A5.882,5.882,0,0,1,89.591,18.2l1.052,10.852H63.7Z"
            transform="translate(4597.048 5676.834)"
          />
          <text
            id="_16_Mins"
            data-name="16 Mins"
            transform="translate(4794.923 5720.474)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-80.735" y="0">
              16 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="bellagio_convention_tcolv_levle1_walking_info"
          transform="translate(3173.673 -1821.116)"
          opacity="0"
        >
          <path
            id="Path_8-21"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-21"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-19"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_12_Mins"
            data-name="12 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-80.667" y="0">
              12 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="bellagio_convention_tcolv_levle2_walking_info"
          transform="translate(3800 -1899.116)"
          opacity="0"
        >
          <path
            id="Path_8-22"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-22"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-20"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_12_Mins-2"
            data-name="12 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-80.667" y="0">
              12 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="bellagio_convention_tcolv_levle3_walking_info"
          transform="translate(3173.673 -1821.116)"
          opacity="0"
        >
          <path
            id="Path_8-23"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-23"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-21"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_12_Mins-3"
            data-name="12 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-80.667" y="0">
              12 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="bellagio_convention_to_rafael_walking_info"
          transform="translate(3700-1899.116)"
          opacity="0"
        >
          <path
            id="Path_8-24"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-24"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-22"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_5_Mins"
            data-name="5 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-71.211" y="0">
              5 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="bellagio_convention_to_silk_road_walking_info"
          transform="translate(3173.673 -1821.116)"
          opacity="0"
        >
          <path
            id="Path_8-25"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-25"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-23"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_5_Mins-2"
            data-name="5 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-71.211" y="0">
              5 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="park_mgm_conferance_to_vdara_raphael_walking_info"
          transform="translate(1216.096 -1979.791)"
          opacity="0"
        >
          <path
            id="Path_8-26"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-26"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-24"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_12_Mins-4"
            data-name="12 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-80.667" y="0">
              12 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="park_mgm_conferance_to_vdara_raphael_tram_info"
          transform="translate(1648.085 -436.022)"
          opacity="0"
        >
          <path
            id="Path_8-27"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.329) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-27"
            data-name="Rectangle 5"
            width="342.915"
            height="109.309"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="Path_563-3"
            data-name="Path 563"
            d="M95.675,31.565,93.907,13.3a7.922,7.922,0,0,0-7.621-7.44H81.88V3.512h1.658a1.174,1.174,0,0,1,.985.557,1.536,1.536,0,0,0,2.2.369,1.849,1.849,0,0,0,.468-2.355A4.346,4.346,0,0,0,83.535,0H70.829a4.349,4.349,0,0,0-3.651,2.081,1.85,1.85,0,0,0,.414,2.442,1.542,1.542,0,0,0,2.252-.449,1.174,1.174,0,0,1,.985-.557h1.658V5.868H68.075a7.923,7.923,0,0,0-7.621,7.444L58.686,31.6a8.993,8.993,0,0,0,.218,3.008L60.672,41.8a8.016,8.016,0,0,0,5.389,5.874L64.239,53.3a1.8,1.8,0,0,0,.992,2.239A1.591,1.591,0,0,0,67.3,54.465l2.1-6.5H84.959l2.1,6.5a1.591,1.591,0,0,0,2.064,1.075,1.8,1.8,0,0,0,.992-2.239L88.3,47.67a8.018,8.018,0,0,0,5.389-5.885l1.768-7.218A8.974,8.974,0,0,0,95.675,31.565ZM75.722,3.512h2.915V5.863H75.722ZM72.227,40.625a.743.743,0,0,1-.711.771H66.425a.728.728,0,0,1-.7-.62l-.57-3.114a.819.819,0,0,1,.148-.64.69.69,0,0,1,.55-.281h5.658a.743.743,0,0,1,.711.771v3.114Zm16.979-2.963-.57,3.114a.731.731,0,0,1-.7.621H82.848a.743.743,0,0,1-.711-.771V37.508a.743.743,0,0,1,.711-.771h5.658a.691.691,0,0,1,.55.281.819.819,0,0,1,.148.64Zm-25.5-8.612L64.76,18.2a5.882,5.882,0,0,1,5.658-5.526H83.933A5.882,5.882,0,0,1,89.591,18.2l1.052,10.852H63.7Z"
            transform="translate(4597.048 5676.834)"
          />
          <text
            id="_12-19_Mins"
            data-name="12-19 Mins"
            transform="translate(4835.028 5720.474)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-112.681" y="0">
              12-19 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="park_mgm_conferance_to_vdara_silk_tram_info"
          transform="translate(1648.085 -436.022)"
          opacity="0"
        >
          <path
            id="Path_8-28"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.329) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-28"
            data-name="Rectangle 5"
            width="342.915"
            height="109.309"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="Path_563-4"
            data-name="Path 563"
            d="M95.675,31.565,93.907,13.3a7.922,7.922,0,0,0-7.621-7.44H81.88V3.512h1.658a1.174,1.174,0,0,1,.985.557,1.536,1.536,0,0,0,2.2.369,1.849,1.849,0,0,0,.468-2.355A4.346,4.346,0,0,0,83.535,0H70.829a4.349,4.349,0,0,0-3.651,2.081,1.85,1.85,0,0,0,.414,2.442,1.542,1.542,0,0,0,2.252-.449,1.174,1.174,0,0,1,.985-.557h1.658V5.868H68.075a7.923,7.923,0,0,0-7.621,7.444L58.686,31.6a8.993,8.993,0,0,0,.218,3.008L60.672,41.8a8.016,8.016,0,0,0,5.389,5.874L64.239,53.3a1.8,1.8,0,0,0,.992,2.239A1.591,1.591,0,0,0,67.3,54.465l2.1-6.5H84.959l2.1,6.5a1.591,1.591,0,0,0,2.064,1.075,1.8,1.8,0,0,0,.992-2.239L88.3,47.67a8.018,8.018,0,0,0,5.389-5.885l1.768-7.218A8.974,8.974,0,0,0,95.675,31.565ZM75.722,3.512h2.915V5.863H75.722ZM72.227,40.625a.743.743,0,0,1-.711.771H66.425a.728.728,0,0,1-.7-.62l-.57-3.114a.819.819,0,0,1,.148-.64.69.69,0,0,1,.55-.281h5.658a.743.743,0,0,1,.711.771v3.114Zm16.979-2.963-.57,3.114a.731.731,0,0,1-.7.621H82.848a.743.743,0,0,1-.711-.771V37.508a.743.743,0,0,1,.711-.771h5.658a.691.691,0,0,1,.55.281.819.819,0,0,1,.148.64Zm-25.5-8.612L64.76,18.2a5.882,5.882,0,0,1,5.658-5.526H83.933A5.882,5.882,0,0,1,89.591,18.2l1.052,10.852H63.7Z"
            transform="translate(4597.048 5676.834)"
          />
          <text
            id="_10-17_Mins"
            data-name="10-17 Mins"
            transform="translate(4835.028 5720.474)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-112.164" y="0">
              10-17 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="park_mgm_conferance_to_vdara_silk_walking_info"
          transform="translate(1216.096 -1909.791)"
          opacity="0"
        >
          <path
            id="Path_8-29"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.333) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-29"
            data-name="Rectangle 5"
            width="302.808"
            height="109.407"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="walking-25"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4651.032 5675.383)"
            fill="#1a1a1a"
          />
          <text
            id="_11_Mins-9"
            data-name="11 Mins"
            transform="translate(4801.921 5723.971)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-77.075" y="0">
              11 Mins
            </tspan>
          </text>
        </g>

        <g
          id="aria_to_vdara"
          className="svg-path"
          data-name="aria to vdara"
          transform="translate(2123.644 0)"
          opacity="0"
        >
          <g
            id="Group_3123-8"
            data-name="Group 3123"
            transform="translate(900.214 200.978)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -3521.26, -1403.14)"
              filter="url(#Union_1-12)"
            >
              <path
                id="Union_1-51"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(3521.26 1403.14)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-12"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-12"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-12"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  7 Mins
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Path_2121"
            data-name="Path 2121"
            d="M-4690.107-11750.766l37.586,25.3,90.973-10.156,46.055,57.141,99.44,88.191,59.168,45.387,73.212,14.324h72.408l54.484-14.324,46.491-19.594,42.361-25.793,37.8-34.277,22.948-32.77,23.17-43.24,25.494-35.045-3.461-39.256v-61.4h36.232"
            transform="translate(4690.107 12170.588)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2096-8"
            data-name="Path 2096"
            d="M-3399.313-12062.4l19.4-66.406,19.021-53.776v-50.782l-19.021-64.392-11.169-30.893,38.044-14.135,15.88-28.621v-25.3"
            transform="translate(4169.299 12396.709)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
        </g>

        <g
          id="aria_to_cosmos"
          className="svg-path"
          data-name="aria to cosmos"
          transform="translate(2123.644 143.713)"
          opacity="0"
        >
          <g
            id="Group_3123-9"
            data-name="Group 3123"
            transform="translate(616.27)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -3237.32, -1345.88)"
              filter="url(#Union_1-13)"
            >
              <path
                id="Union_1-52"
                data-name="Union 1"
                d="M127.008,139.719H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H172.445l-22.719,25.4Z"
                transform="translate(3237.32 1345.88)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-13"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-13"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-13"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  8 Mins
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Path_2096-9"
            data-name="Path 2096"
            d="M-3005.949-11602.681v84.169l20.807,74.905,23.223,40.271,10.874,29.4v56.113l20.807,35.3s-9.8,362.579-12.216,369.829-8.591,48.863-8.591,48.863l-10.874,134.239"
            transform="translate(4010.585 11932.623)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2122"
            data-name="Path 2122"
            d="M-4690.107-11750.766l37.586,25.3,90.973-10.156,46.055,57.141,99.44,88.191,59.168,45.387,73.212,14.324h72.408l54.484-14.324,46.491-19.594,42.361-25.793,37.8-34.277,22.948-32.77,23.17-43.24,25.494-35.045-3.461-39.256v-61.4h36.232l66.787,18.4,121.125,43,55.348,74.3"
            transform="translate(4690.107 12026.875)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
        </g>

        <g
          id="aria_to_parkmgm"
          className="svg-path"
          data-name="aria to parkmgm"
          transform="translate(721.184 606.09)"
          opacity="0"
        >
          <path
            id="Path_2096-10"
            data-name="Path 2096"
            d="M-6087.817-11380.669l-72.946,54.072v230l46.071,69.8-46.071,57.24-74.516-22.338h-291.957l-52.354-76.085-228.436-112.562-71.374,93.538-80.8-52.354-52.354,71.377-28.619,41.183,47.467,14.31h9.6"
            transform="translate(7041.172 11380.669)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-10"
            data-name="Group 3123"
            transform="translate(326.951 57.193)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -1545.54, -1865.45)"
              filter="url(#Union_1-14)"
            >
              <path
                id="Union_1-53"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(1545.54 1865.45)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-14"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-14"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-14"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  8 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="aria_to_nomad"
          className="svg-path"
          data-name="aria to nomad"
          transform="translate(466.269 606.09)"
          opacity="0"
        >
          <path
            id="Path_2096-11"
            data-name="Path 2096"
            d="M-6260.24-11380.669l-72.945,54.072v230l46.071,69.8-46.071,57.24-74.516-22.338h-291.958l-52.353-76.085-228.435-112.562-71.376,93.538-80.8-52.354-52.353,71.377-48.052-19.023-49.431,12.775-35.562,62.2-27.739,8.371-47.213-15.575-.02-.007-13.319,26.09-13.319,6.723-48.881-32.812,27.189-62.751"
            transform="translate(7468.508 11380.669)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-11"
            data-name="Group 3123"
            transform="translate(337.338 19.015)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -1301.01, -1827.27)"
              filter="url(#Union_1-15)"
            >
              <path
                id="Union_1-54"
                data-name="Union 1"
                d="M127.008,139.719H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H172.446l-22.719,25.4Z"
                transform="translate(1301.01 1827.27)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-15"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-15"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-15"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  9 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="aria_to_dolby"
          className="svg-path"
          data-name="aria to dolby"
          transform="translate(463.237 606.09)"
          opacity="0"
        >
          <path
            id="Path_2096-12"
            data-name="Path 2096"
            d="M-6262.29-11380.669l-72.945,54.072v230l46.071,69.8-46.071,57.24-74.517-22.338h-291.957l-52.354-76.085-228.435-112.562-71.375,93.538-80.8-52.354-52.353,71.377-148.7,230.879-82.96,65.775-14.632,61.08,6.041,85.376v203.911h-46.313"
            transform="translate(7473.592 11380.669)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-12"
            data-name="Group 3123"
            transform="translate(339.774 21.475)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -1300.42, -1829.73)"
              filter="url(#Union_1-16)"
            >
              <path
                id="Union_1-55"
                data-name="Union 1"
                d="M127.008,139.719H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H172.446l-22.719,25.4Z"
                transform="translate(1300.42 1829.73)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-16"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-16"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-16"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  11 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="aria_to_tmobile"
          className="svg-path"
          data-name="aria to tmobile"
          transform="translate(39.003 424.436)"
          opacity="0"
        >
          <path
            id="Path_2096-13"
            data-name="Path 2096"
            d="M-6549.236-11503.537l-72.946,54.072v230.006l46.072,69.8-46.072,57.24-74.516-22.336h-291.958l-52.354-76.088-228.435-112.559-71.375,93.535-80.8-52.352-52.354,71.375-37.273-13.527-10.715-50.814-30.094-108.168-70.9-29.385-33.009,17.254,5.751,37.895v65.229l-55.855,32.932-71.613,48.586-176.865,6.563-91.7-16.467,10-125.342-148.526-359.105"
            transform="translate(8184.772 11685.191)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 35"
          />
          <g
            id="Group_3123-13"
            data-name="Group 3123"
            transform="translate(861.24 194.108)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -1397.65, -1820.71)"
              filter="url(#Union_1-17)"
            >
              <path
                id="Union_1-56"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(1397.65 1820.71)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-17"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-17"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-17"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  12 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="vdara_to_cosmos"
          className="svg-path"
          data-name="vdara to cosmos"
          transform="translate(2893.63 0)"
          opacity="0"
        >
          <g
            id="Group_3123-14"
            data-name="Group 3123"
            transform="translate(130.229 200.978)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -3521.26, -1403.14)"
              filter="url(#Union_1-18)"
            >
              <path
                id="Union_1-57"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(3521.26 1403.14)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-18"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-18"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-18"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  2 Mins
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Path_2096-14"
            data-name="Path 2096"
            d="M-3337.155-12396.709v25.3l-15.88,28.621-38.044,14.135,11.169,30.893,19.021,64.392v50.782l-19.021,53.776-19.4,66.406,72.918,21.685,104.691,36.061,56.808,69.87"
            transform="translate(3399.313 12396.709)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2123"
            data-name="Path 2123"
            d="M-3005.949-11602.681v84.169l20.807,74.905,23.223,40.271,10.874,29.4v56.113l20.807,35.3s-9.8,362.579-12.216,369.829-8.591,48.863-8.591,48.863l-10.874,134.239"
            transform="translate(3240.599 12076.335)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
        </g>

        <g
          id="vdara_to_parkmgm"
          className="svg-path"
          data-name="vdara to parkmgm"
          transform="translate(721.184 0)"
          opacity="0"
        >
          <path
            id="Path_2096-15"
            data-name="Path 2096"
            d="M-4868.727-11836.281h-41.861v61.4l3.461,39.256-25.493,35.045-23.17,43.24-22.949,32.77-37.795,34.277-42.36,25.793-46.491,19.594-54.483,14.324h-72.408l-73.212-14.324-59.17-45.387-99.438-88.191-46.056-57.141-90.6,42.832-84.114,34.9-45.9,36.471-68.235-19.02h-79.4l-209.413,75.939-72.946,54.07v230.008l46.071,69.8-46.071,57.24-74.516-22.338h-291.957l-52.354-76.086-228.436-112.561-71.374,93.539-80.8-52.354-52.354,71.375-28.619,41.184,47.467,14.311h9.6"
            transform="translate(7041.172 12170.588)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-15"
            data-name="Group 3123"
            transform="translate(1148.406 339.967)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-19)"
            >
              <path
                id="Union_1-58"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-19"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-19"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-19"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  12 Mins
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Path_2124"
            data-name="Path 2124"
            d="M-3337.155-12396.709v25.3l-15.88,28.621-38.044,14.135,11.169,30.893,19.021,64.392v50.782l-19.021,53.776-19.4,66.406"
            transform="translate(5571.758 12396.709)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
        </g>

        <g
          id="vdara_to_parkmgm1"
          className="svg-path"
          data-name="vdara to parkmgm"
          transform="translate(721.184 0)"
          opacity="0"
        >
          <path
            id="Path_2134"
            data-name="Path 2134"
            d="M-9951.586-11512.082c50.48,12.9,199.171,48.875,199.171,48.875l113.328,42.228h171l180.568,6.46v-95.957l-66.651,23.635h-99.5l-58.278,3.257h-79.855l-47.28,2.819-61.175,28.487-109.788,60.426-66.06,64.316-65.239,82.856-43.731,82.854-41.479,128.124-29.8,134.984-30.726,101.493-44.652,97.809-51.209,54.9-17.616,15.875-67.9,20.483-165.812,26.116-143.383,12.084-231.769,14.032-58.274-6.556-54.077-8.4-93.095-23.248-81.934-39.123-69.849-35.437-59.605-36.256L-11283-10741.3l-98.73-64.215-72.613-47.521-74.456-55.816-33.49-23.25-57.542,48.113"
            transform="translate(12124.096 11846.508)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />

          <g
            id="Group_3152"
            data-name="Group 3152"
            transform="translate(1364.853 1097.953)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2583.44, -2300.12)"
              filter="url(#Union_1-20)"
            >
              <path
                id="Union_1-40"
                data-name="Union 1"
                d="M32.021,139.719H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H332.76a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H87.065l-27.522,25.4Z"
                transform="translate(2583.44 2300.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-20"
              data-name="Group 3119"
              transform="translate(53.598 33.473)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />
              <text
                id="_12-19_Mins"
                data-name="12-19 Mins"
                transform="translate(82.322 49)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  12 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="vdara_to_nomad"
          className="svg-path"
          data-name="vdara to nomad"
          transform="translate(466.269 0)"
          opacity="0"
        >
          <path
            id="Path_2096-16"
            data-name="Path 2096"
            d="M-5041.148-11836.281h-41.861v61.4l3.461,39.256-25.493,35.045-23.17,43.24-22.949,32.77-37.794,34.277-42.362,25.793-46.49,19.594-54.484,14.324H-5404.7l-73.212-14.324-59.168-45.387-99.44-88.191-46.054-57.141-90.6,42.832-84.114,34.9-45.9,36.471-68.233-19.02h-79.4l-209.414,75.939-72.945,54.07v230.008l46.071,69.8-46.071,57.24-74.516-22.338h-291.958l-52.353-76.086-228.435-112.561-71.376,93.539-80.8-52.354-52.353,71.375-48.052-19.021-49.431,12.773-35.562,62.2-27.739,8.371-47.213-15.574-.02-.006-13.319,26.09-13.319,6.721-48.881-32.811,27.189-62.752"
            transform="translate(7468.508 12170.588)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2126"
            data-name="Path 2126"
            d="M-3337.155-12396.709v25.3l-15.88,28.621-38.044,14.135,11.169,30.893,19.021,64.392v50.782l-19.021,53.776-19.4,66.406"
            transform="translate(5826.674 12396.709)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-16"
            data-name="Group 3123"
            transform="translate(1403.321 339.967)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-21)"
            >
              <path
                id="Union_1-60"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-21"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-21"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-21"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  13 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="vdara_to_nomad1"
          className="svg-path"
          ata-name="vdara to parkmgm"
          transform="translate(721.184 0)"
          opacity="0"
        >
          <path
            id="Path_2134"
            data-name="Path 2134"
            d="M-9951.586-11512.082c50.48,12.9,199.171,48.875,199.171,48.875l113.328,42.228h171l180.568,6.46v-95.957l-66.651,23.635h-99.5l-58.278,3.257h-79.855l-47.28,2.819-61.175,28.487-109.788,60.426-66.06,64.316-65.239,82.856-43.731,82.854-41.479,128.124-29.8,134.984-30.726,101.493-44.652,97.809-51.209,54.9-17.616,15.875-67.9,20.483-165.812,26.116-143.383,12.084-231.769,14.032-58.274-6.556-54.077-8.4-93.095-23.248-81.934-39.123-69.849-35.437-59.605-36.256L-11283-10741.3l-98.73-64.215-72.613-47.521-74.456-55.816-33.49-23.25-57.542,48.113"
            transform="translate(12124.096 11846.508)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />

          <g
            id="Group_3152"
            data-name="Group 3152"
            transform="translate(1364.853 1097.953)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2583.44, -2300.12)"
              filter="url(#Union_1-20)"
            >
              <path
                id="Union_1-40"
                data-name="Union 1"
                d="M32.021,139.719H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H332.76a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H87.065l-27.522,25.4Z"
                transform="translate(2583.44 2300.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-20"
              data-name="Group 3119"
              transform="translate(53.598 33.473)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />
              <text
                id="_12-19_Mins"
                data-name="12-19 Mins"
                transform="translate(82.322 49)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  13 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="vdara_to_dolby"
          className="svg-path"
          data-name="vdara to dolby"
          transform="translate(463.237 0)"
          opacity="0"
        >
          <g
            id="Group_3123-17"
            data-name="Group 3123"
            transform="translate(1406.353 339.967)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-22)"
            >
              <path
                id="Union_1-61"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-22"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-22"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-22"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  15 Mins
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Path_2125"
            data-name="Path 2125"
            d="M-3337.155-12396.709v25.3l-15.88,28.621-38.044,14.135,11.169,30.893,19.021,64.392v50.782l-19.021,53.776-19.4,66.406"
            transform="translate(5829.707 12396.709)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2096-17"
            data-name="Path 2096"
            d="M-5043.2-11836.281h-41.861v61.4l3.463,39.256-25.494,35.045-23.17,43.24-22.949,32.77-37.795,34.277-42.361,25.793-46.49,19.594-54.484,14.324h-72.407l-73.213-14.324-59.169-45.387-99.439-88.191-46.055-57.141-90.6,42.832-84.114,34.9-45.9,36.471-68.234-19.02h-79.4l-209.414,75.939-72.945,54.07v230.008l46.071,69.8-46.071,57.24-74.517-22.338h-291.957l-52.354-76.086-228.435-112.561-71.375,93.539-80.8-52.354-52.353,71.375-148.7,230.879-82.96,65.777-14.632,61.08,6.041,85.375v203.91h-46.313"
            transform="translate(7473.592 12170.588)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
        </g>

        <g
          id="vdara_to_dolby1"
          className="svg-path"
          data-name="vdara to dolby"
          transform="translate(463.237 0)"
          opacity="0"
        >
          <path
            id="Path_2139"
            data-name="Path 2139"
            d="M-9963.795-11512.574l128.571,35.217,141.808,38.682,93.121,21.429h214.129l79.491-15.048v-71.613l-41.518,11.5-98.872,8.624h-157.207l-47.278,2.816-61.174,28.489-109.791,60.426-66.06,64.316-65.237,82.855-43.733,82.855-41.478,128.121-29.8,134.985-30.724,101.5-44.654,97.807-51.209,54.9-17.614,15.876-67.9,20.482-165.812,26.115-143.383,12.086-231.769,14.03-58.274-6.556-54.075-8.4-93.1-23.248-81.933-39.123-69.849-35.436-59.605-36.256-56.739-36.358-98.729-64.215-72.613-47.521-74.457-55.816-33.489-23.249-75.972,23.249"
            transform="translate(12394.509 11846.707)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />

          <g
            id="Group_3152"
            data-name="Group 3152"
            transform="translate(1364.853 1097.953)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2583.44, -2300.12)"
              filter="url(#Union_1-20)"
            >
              <path
                id="Union_1-40"
                data-name="Union 1"
                d="M32.021,139.719H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H332.76a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H87.065l-27.522,25.4Z"
                transform="translate(2583.44 2300.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-20"
              data-name="Group 3119"
              transform="translate(53.598 33.473)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />
              <text
                id="_12-19_Mins"
                data-name="12-19 Mins"
                transform="translate(82.322 49)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  15 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="vdara_to_tmobile"
          className="svg-path"
          data-name="vdara to tmobile"
          transform="translate(39.003 0)"
          opacity="0"
        >
          <path
            id="Path_2096-18"
            data-name="Path 2096"
            d="M-4871.637-11836.281H-4913.5v61.4l3.461,39.256-25.494,35.045-23.17,43.24-22.948,32.77-37.8,34.277-42.361,25.793-46.491,19.594-54.484,14.324h-72.407l-73.212-14.324-59.169-45.387-99.439-88.191-46.055-57.141-90.6,42.832-84.114,34.9-45.9,36.471-68.234-19.02h-79.4l-209.413,75.939-72.946,54.07v230.008l46.071,69.8-46.071,57.24-74.516-22.338h-291.958l-52.353-76.086-228.436-112.561-71.375,93.539-80.8-52.354-52.353,71.375-32.924-7.568"
            transform="translate(7726.264 12170.588)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2126-2"
            data-name="Path 2126"
            d="M-3337.155-12396.709v25.3l-15.88,28.621-38.044,14.135,11.169,30.893,19.021,64.392v50.782l-19.021,53.776-19.4,66.406"
            transform="translate(6253.94 12396.709)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2131"
            data-name="Path 2131"
            d="M-7511.245-11204.367l-10.715-50.814-30.094-108.168-70.9-29.385-33.009,17.254,5.751,37.895v65.229l-55.855,32.932-71.613,48.586-176.865,6.563-91.7-16.467,10-125.342-148.526-359.105"
            transform="translate(8184.772 12109.627)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-18"
            data-name="Group 3123"
            transform="translate(1830.587 339.967)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-24)"
            >
              <path
                id="Union_1-63"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-24"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-24"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-24"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  16 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="vdara_to_tmobile1"
          className="svg-path"
          data-name="vdara to tmobile"
          transform="translate(39.003 0)"
          opacity="0"
        >
          <path
            id="Path_2140"
            data-name="Path 2140"
            d="M-9970.9-11517.483l43.733,16.8,154.649,33.491,135.906,39.122,119.111,9.217,121.056-4.608,91.255,13.007v-90.229l-43.732,17.742-173.054-2.819h-79.855l-47.278,2.819-61.174,28.486-109.791,60.426-66.059,64.316-65.239,82.856-43.731,82.854-41.479,128.123-29.8,134.983-30.726,101.5-44.653,97.808-51.208,54.9-17.615,15.875-67.9,20.484-165.812,26.114-143.383,12.086-231.768,14.03-58.275-6.554-54.075-8.4-93.1-23.248-81.933-39.124-69.849-35.436-59.605-36.256-56.738-36.357-98.729-64.214-72.614-47.521-74.456-55.817s-25.118-17.436-33.489-23.249-72.367,25.01-72.367,25.01"
            transform="translate(12816.305 11848.687)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />

          <g
            id="Group_3154"
            data-name="Group 3154"
            transform="translate(2055.034 1096.953)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2591.44, -2299.12)"
              filter="url(#Union_1-20)"
            >
              <path
                id="Union_1-40"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H330.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2591.44 2299.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-20"
              data-name="Group 3119"
              transform="translate(53.598 35.526)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />

              <text
                id="_12-19_Mins"
                data-name="12-19 Mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  16 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="cosmos_to_parkmgm"
          className="svg-path"
          data-name="cosmos to parkmgm"
          transform="translate(721.184 334.307)"
          opacity="0"
        >
          <g
            id="Group_3123-19"
            data-name="Group 3123"
            transform="translate(1148.406 5.661)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-26)"
            >
              <path
                id="Union_1-65"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-26"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-26"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-26"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  13 Mins
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Path_2096-19"
            data-name="Path 2096"
            d="M-6984.107-11196.307h-9.6l-47.467-14.311,28.619-41.184,52.354-71.375,80.8,52.354,71.374-93.539,228.436,112.561,52.354,76.086h291.957l74.516,22.338,46.071-57.24-46.071-69.8v-230.008l72.946-54.07,209.413-75.939h79.4l68.235,19.02,45.9-36.471,84.114-34.9,90.6-42.832,46.056,57.141,99.438,88.191,59.17,45.387,73.212,14.324h72.408l54.483-14.324,46.491-19.594,42.36-25.793,37.795-34.277,22.949-32.77,23.17-43.24,25.493-35.045-3.461-39.256v-61.4h41.861l72.917,21.686,104.691,36.061,57.838,70.336"
            transform="translate(7041.172 11836.281)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2127"
            data-name="Path 2127"
            d="M-3005.949-11602.681v84.169l20.807,74.905,23.223,40.271,10.874,29.4v56.113l20.807,35.3s-9.8,362.579-12.216,369.829-8.591,48.863-8.591,48.863l-10.874,134.239"
            transform="translate(5413.044 11742.029)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
        </g>

        <g
          id="cosmos_to_parkmgm1"
          className="svg-path"
          data-name="cosmos to parkmgm"
          transform="translate(721.184 334.307)"
          opacity="0"
        >
          <path
            id="Path_2141"
            data-name="Path 2141"
            d="M-9730.683-11384.2l25.151-16.74,54.938-14.031,86.543,5.633h265.466v-83.777l-72.718,27.857-145.92-10.672h-79.855l-47.28,2.818-61.174,28.486-109.789,60.426-66.06,64.318-65.24,82.854-43.73,82.857-41.479,128.121-29.8,134.984-30.725,101.5-44.654,97.807-51.208,54.895-17.615,15.875-67.9,20.484-165.812,26.115-143.385,12.084-231.767,14.033-58.276-6.557-54.074-8.4-93.1-23.25-81.933-39.123-69.849-35.436-59.606-36.254-56.737-36.359-98.73-64.215-72.613-47.521-74.456-55.816-33.49-23.25-65.334,41.7"
            transform="translate(12129.366 11504.55)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3155"
            data-name="Group 3155"
            transform="translate(1372.853 762.646)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2591.44, -2299.12)"
              filter="url(#Union_1-27)"
            >
              <path
                id="Union_1-66"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2591.44 2299.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-27"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />
              <text
                id="_10_mins-27"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  12 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="cosmos_to_nomad"
          className="svg-path"
          data-name="cosmos to nomad"
          transform="translate(721.184 334.307)"
          opacity="0"
        >
          <g
            id="Group_3123-20"
            data-name="Group 3123"
            transform="translate(1148.406 5.661)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-28)"
            >
              <path
                id="Union_1-67"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-28"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-28"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-28"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  14 Mins
                </tspan>
              </text>
            </g>
          </g>

          <path
            id="Path_2127-3"
            data-name="Path 2127"
            d="M-3005.949-11602.681v84.169l20.807,74.905,23.223,40.271,10.874,29.4v56.113l20.807,35.3s-9.8,362.579-12.216,369.829-8.591,48.863-8.591,48.863l-10.874,134.239"
            transform="translate(5413.044 11742.029)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />

          <path
            id="Path_2096-23"
            data-name="Path 2096"
            d="M-4633.28-11708.2l-57.838-70.336-104.691-36.061-72.917-21.686h-41.861v61.4l3.461,39.256-25.493,35.045-23.17,43.24-22.949,32.77-37.795,34.277-42.36,25.793-46.491,19.594-54.483,14.324h-72.408l-73.212-14.324-59.17-45.387-99.438-88.191-46.056-57.141-90.6,42.832-84.114,34.9-45.9,36.471-68.235-19.02h-79.4l-209.413,75.939-72.946,54.07v230.008l46.071,69.8-46.071,57.24-74.516-22.338h-291.957l-52.354-76.086-228.436-112.561-71.374,93.539-80.8-52.354-52.354,71.375-62.556,74.328-44.439-28.763-88.877,8.485-25.527,3.882-3.883,25.527-19.63-9.132-49.041-28.763,28.763-39.908"
            transform="translate(7041.172 11836.281)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
        </g>

        <g
          id="cosmos_to_nomad1"
          className="svg-path"
          data-name="cosmos to nomad"
          transform="translate(721.184 334.307)"
          opacity="0"
        >
          <path
            id="Path_2142"
            data-name="Path 2142"
            d="M-9730.683-11384.2l25.151-16.74,54.938-14.031,86.543,5.633h265.466v-83.777l-72.718,27.857-145.92-10.672h-79.855l-47.28,2.818-61.174,28.486-109.789,60.426-66.06,64.318-65.24,82.854-43.73,82.857-41.479,128.121-29.8,134.984-30.725,101.5-44.654,97.807-51.208,54.895-17.615,15.875-67.9,20.484-165.812,26.115-143.385,12.084-231.767,14.033-58.276-6.557-54.074-8.4-93.1-23.25-81.933-39.123-69.849-35.436-59.606-36.254-56.737-36.359-98.73-64.215-72.613-47.521-74.456-55.816-33.49-23.25-65.334,41.7"
            transform="translate(12129.366 11504.55)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3156"
            data-name="Group 3156"
            transform="translate(1372.853 762.646)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2591.44, -2299.12)"
              filter="url(#Union_1-29)"
            >
              <path
                id="Union_1-68"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2591.44 2299.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-29"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />
              <text
                id="_10_mins-29"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  13 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="cosmos_to_dolby"
          className="svg-path"
          data-name="cosmos to dolby"
          transform="translate(463.237 334.307)"
          opacity="0"
        >
          <g
            id="Group_3123-21"
            data-name="Group 3123"
            transform="translate(1406.353 5.661)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-30)"
            >
              <path
                id="Union_1-69"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-30"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-30"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-30"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  16 Mins
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Path_2127-3"
            data-name="Path 2127"
            d="M-3005.949-11602.681v84.169l20.807,74.905,23.223,40.271,10.874,29.4v56.113l20.807,35.3s-9.8,362.579-12.216,369.829-8.591,48.863-8.591,48.863l-10.874,134.239"
            transform="translate(5670.992 11742.029)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2128"
            data-name="Path 2128"
            d="M-7473.592-10604.779h46.313v-203.91l-6.041-85.375,14.632-61.08,82.96-65.777,148.7-230.879,52.353-71.375,80.8,52.354,71.375-93.539,228.435,112.561,52.354,76.086h291.957l74.517,22.338,46.071-57.24-46.071-69.8v-230.008l72.945-54.07,209.414-75.939h79.4l68.234,19.02,45.9-36.471,84.114-34.9,90.6-42.832,46.055,57.141,99.439,88.191,59.169,45.387,73.213,14.324h72.407l54.484-14.324,46.49-19.594,42.361-25.793,37.795-34.277,22.949-32.77,23.17-43.24,25.494-35.045-3.463-39.256v-61.4h41.861l72.918,21.686,104.691,36.061,53.292,68.4"
            transform="translate(7473.592 11836.281)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
        </g>

        <g
          id="cosmos_to_dolby1"
          className="svg-path"
          data-name="cosmos to dolby"
          transform="translate(463.237 334.307)"
          opacity="0"
        >
          <path
            id="Path_2143"
            data-name="Path 2143"
            d="M-9730.683-11384.2l25.151-16.74,54.938-14.031,86.543,5.633h265.466v-83.777l-72.718,27.857-145.92-10.672h-79.855l-47.28,2.818-61.174,28.486-109.789,60.426-66.06,64.318-65.24,82.854-43.73,82.857-41.479,128.121-29.8,134.984-30.725,101.5-44.654,97.807-51.208,54.895-17.615,15.875-67.9,20.484-165.812,26.115-143.385,12.084-231.767,14.033-58.276-6.557-54.074-8.4-93.1-23.25-81.933-39.123-69.849-35.436-59.606-36.254-56.737-36.359-98.73-64.215-72.613-47.521-74.456-55.816-33.49-23.25-65.334,41.7"
            transform="translate(12387.313 11504.55)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3158"
            data-name="Group 3158"
            transform="translate(1630.801 762.646)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2591.44, -2299.12)"
              filter="url(#Union_1-32)"
            >
              <path
                id="Union_1-71"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2591.44 2299.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-32"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />

              <text
                id="_10_mins-32"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  15 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="cosmos_to_tmobile"
          className="svg-path"
          data-name="cosmos to tmobile"
          transform="translate(39.003 334.307)"
          opacity="0"
        >
          <path
            id="Path_2096-21"
            data-name="Path 2096"
            d="M-7048.386-11259.369l32.924,7.568,52.353-71.375,80.8,52.354,71.375-93.539L-6582.5-11251.8l52.353,76.086h291.958l74.516,22.338,46.071-57.24-46.071-69.8v-230.008l72.946-54.07,209.413-75.939h79.4l68.234,19.02,45.9-36.471,84.114-34.9,90.6-42.832,46.055,57.141,99.439,88.191,59.169,45.387,73.212,14.324h72.407l54.484-14.324,46.491-19.594,42.361-25.793,37.8-34.277,22.948-32.77,23.17-43.24,25.494-35.045-3.461-39.256v-61.4h41.861l189.557,61.4,51.926,74.3"
            transform="translate(7726.264 11836.281)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2132"
            data-name="Path 2132"
            d="M-3005.949-11602.681v84.169l20.807,74.905,23.223,40.271,10.874,29.4v56.113l20.807,35.3s-9.8,362.579-12.216,369.829-8.591,48.863-8.591,48.863l-10.874,134.239"
            transform="translate(6095.226 11742.029)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2131-2"
            data-name="Path 2131"
            d="M-7511.245-11204.367l-10.715-50.814-30.094-108.168-70.9-29.385-33.009,17.254,5.751,37.895v65.229l-55.855,32.932-71.613,48.586-176.865,6.563-91.7-16.467,10-125.342-148.526-359.105"
            transform="translate(8184.772 11775.319)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-22"
            data-name="Group 3123"
            transform="translate(1830.587 5.661)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2367, -1542.13)"
              filter="url(#Union_1-33)"
            >
              <path
                id="Union_1-72"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2367 1542.13)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-33"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-33"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-33"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  17 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="cosmos_to_tmobile_1"
          className="svg-path"
          transform="translate(39.003 334.307)"
          opacity="0"
        >
          <path
            id="Path_2144"
            data-name="Path 2144"
            d="M-9730.683-11384.2l25.151-16.74,54.938-14.031,86.543,5.633h265.466v-83.777l-72.718,27.857-145.92-10.672h-79.855l-47.28,2.818-61.174,28.486-109.789,60.426-66.06,64.318-65.24,82.854-43.73,82.857-41.479,128.121-29.8,134.984-30.725,101.5-44.654,97.807-51.208,54.895-17.615,15.875-67.9,20.484-165.812,26.115-143.385,12.084-231.767,14.033-58.276-6.557-54.074-8.4-93.1-23.25-81.933-39.123-69.849-35.436-59.606-36.254-56.737-36.359-98.73-64.215-72.613-47.521-74.456-55.816-33.49-23.25-65.334,41.7"
            transform="translate(12811.547 11504.55)"
            fill="none"
            stroke="#6a9cff"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3159"
            data-name="Group 3159"
            transform="translate(2055.034 762.646)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -2591.44, -2299.12)"
              filter="url(#Union_1-34)"
            >
              <path
                id="Union_1-73"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(2591.44 2299.12)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-34"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="Path_2097"
                data-name="Path 2097"
                d="M105.4,36.756l-2.233-21.265A9.675,9.675,0,0,0,93.55,6.827H87.98V4.089h2.094a1.512,1.512,0,0,1,1.244.656,2.045,2.045,0,0,0,3.367-2.321A5.6,5.6,0,0,0,90.074,0H74.028a5.6,5.6,0,0,0-4.611,2.424,2.045,2.045,0,1,0,3.367,2.321,1.512,1.512,0,0,1,1.244-.656h2.094V6.827H70.553a9.675,9.675,0,0,0-9.622,8.666L58.7,36.795a9.681,9.681,0,0,0,.274,3.5L61.2,48.665a9.676,9.676,0,0,0,6.813,6.841l-2.3,6.558a2.045,2.045,0,1,0,3.859,1.353l2.655-7.572H91.87l2.655,7.572a2.045,2.045,0,1,0,3.859-1.353l-2.3-6.558a9.676,9.676,0,0,0,6.815-6.852l2.233-8.4A9.664,9.664,0,0,0,105.4,36.756ZM80.211,4.089h3.68V6.827h-3.68V4.089ZM75.795,47.3a.9.9,0,0,1-.9.9H68.47a.9.9,0,0,1-.882-.724l-.719-3.626a.9.9,0,0,1,.882-1.074H74.9a.9.9,0,0,1,.9.9V47.3Zm21.439-3.451-.719,3.626a.9.9,0,0,1-.882.724H89.206a.9.9,0,0,1-.9-.9V43.676a.9.9,0,0,1,.9-.9h7.146a.9.9,0,0,1,.881,1.073ZM65.042,33.829l1.326-12.648a7.184,7.184,0,0,1,7.145-6.435H90.588a7.184,7.184,0,0,1,7.145,6.433l1.328,12.649H65.042Z"
                transform="translate(-58.645)"
              />
              <text
                id="_10_mins-34"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  16 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="parkmgm_to_dolby"
          className="svg-path"
          data-name="parkmgm to dolby"
          transform="translate(463.237 952.624)"
          opacity="0"
        >
          <path
            id="Path_2096-23"
            data-name="Path 2096"
            d="M-7473.592-10186.559h46.313v-203.908l-6.041-85.377,14.632-61.08,82.96-65.777,130.568-197.043,39.123,27.039"
            transform="translate(7473.592 10799.744)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-24"
            data-name="Group 3123"
            transform="translate(70.135 329.847)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -1030.78, -2484.63)"
              filter="url(#Union_1-36)"
            >
              <path
                id="Union_1-75"
                data-name="Union 1"
                d="M53.872,139.719a30,30,0,0,1-30-30V91.208L0,69.859,23.872,48.51V30a30,30,0,0,1,30-30H293.325a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30Z"
                transform="translate(1030.78 2484.63)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-36"
              data-name="Group 3119"
              transform="translate(58.47 35.526)"
            >
              <path
                id="walking-36"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-36"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  3 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="park_mgm_conferance_to_t_mobile_walk"
          className="svg-path"
          transform="translate(39.003 424.436)"
          opacity="0"
        >
          <path
            id="Path_2131"
            data-name="Path 2131"
            d="M-8184.772-11685.191l144.152,336.849-9.71,117.573,89,15.446,171.657-6.155,69.5-45.575,54.21-30.891v-61.186l-5.582-35.546,32.037-16.185,68.816,27.563,29.208,101.464,10.4,47.665,19.506,35.682,18.045,28.894h14.6"
            transform="translate(8206.189 11719.259)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />

          <g
            id="Group_3123-25"
            data-name="Group 3123"
            transform="translate(536.136 109.712)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -1072.54, -1736.31)"
              filter="url(#Union_1-37)"
            >
              <path
                id="Union_1-76"
                data-name="Union 1"
                d="M26.223,139.483A30,30,0,0,1,0,109.718V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H71.871l-22.719,25.4Z"
                transform="translate(1072.54 1736.31)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-37"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-37"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-37"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  4 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        <g
          id="park_mgm_to_nomad"
          className="svg-path"
          data-name="parkmgm to nomad"
          transform="translate(466.269 710.408)"
          opacity="0"
        >
          <path
            id="Path_2096-22"
            data-name="Path 2096"
            d="M-7035.7-10860.885l-5.47,43.819,47.467,14.31h9.6"
            transform="translate(7296.087 11066.63)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <path
            id="Path_2129"
            data-name="Path 2129"
            d="M-7233.025-10888.354l-49.431,12.775-35.562,62.2-27.739,8.371-47.213-15.574-.02-.006-13.319,26.09-13.319,6.722-48.881-32.812,27.189-62.751"
            transform="translate(7468.508 11077.712)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="20"
            strokeDasharray="0 30"
          />
          <g
            id="Group_3123-23"
            data-name="Group 3123"
            transform="translate(85.758)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -1049.43, -1912.57)"
              filter="url(#Union_1-35)"
            >
              <path
                id="Union_1-74"
                data-name="Union 1"
                d="M127.008,139.719H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H269.453a30,30,0,0,1,30,30v79.718a30,30,0,0,1-30,30H172.446l-22.719,25.4Z"
                transform="translate(1049.43 1912.57)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-35"
              data-name="Group 3119"
              transform="translate(34.598 35.526)"
            >
              <path
                id="walking-35"
                data-name="walking"
                d="M12.708,24.219l10.1-7.333a6.284,6.284,0,0,1,3.916-1.21,8.24,8.24,0,0,1,7.645,5.733,13.9,13.9,0,0,0,1.607,3.723,15.726,15.726,0,0,0,12.594,6.294v6.3A22.006,22.006,0,0,1,31.549,29.7l-2.2,12.459,6.492,5.45,7,19.241-5.922,2.155L30.5,51.354,19.821,42.392a6.3,6.3,0,0,1-2.246-6l1.6-9.088-2.133,1.55-6.7,9.224-5.1-3.7,7.406-10.194ZM31.241,14.1A6.3,6.3,0,1,1,35.7,12.255,6.3,6.3,0,0,1,31.241,14.1ZM21.878,55.622,11.754,67.687,6.928,63.639,16.3,52.469l2.35-6.867,5.642,4.725Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_10_mins-35"
                data-name="10 mins"
                transform="translate(68.016 47.947)"
                fill="#1a1a1a"
                fontSize="45"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  1 Mins
                </tspan>
              </text>
            </g>
          </g>
        </g>

        {/* <g
          id="park_mgm_to_nomad"
          data-name="park mgm to nomad"
          className="svg-path"
          opacity="0"
          transform="translate(453.428 648.034)"
        >
          <path
            id="Path_2107-5"
            data-name="Path 2107"
            d="M1940.2,3471.47,1920.66,3459.6v-56.926l8.506-20.377h48.42v77.3l40.849,42.437,28.884-50.042,20.377-28.1,29.725,12.713,15.33,6.824,31.408,28.042c7.852,7.01,29.549-19.476,29.549-19.476"
            transform="translate(-1728.414 -3202.255)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeWidth="30"
            strokeDasharray="0 45"
          />
          <g id="Group_3138" data-name="Group 3138" transform="translate(0 0)">
            <g
              transform="matrix(1, 0, 0, 1, -953.9, -1838.32)"
              filter="url(#Union_1-20)"
            >
              <path
                id="Union_1-44"
                data-name="Union 1"
                d="M196.822,139.77h52.122l-26.06,29.14ZM30,139.77a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H415.767a30,30,0,0,1,30,30V109.77a30,30,0,0,1-30,30Z"
                transform="translate(953.9 1838.32)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_3119-20"
              data-name="Group 3119"
              transform="translate(36.693 35.282)"
            >
              <path
                id="walking-18"
                data-name="walking"
                d="M12.711,24.227l10.1-7.336a6.287,6.287,0,0,1,3.917-1.21,8.243,8.243,0,0,1,7.648,5.735,13.9,13.9,0,0,0,1.607,3.725,15.732,15.732,0,0,0,12.6,6.3v6.3a22.014,22.014,0,0,1-17.023-8.026l-2.2,12.463,6.495,5.452,7.005,19.248-5.924,2.155L30.51,51.372,19.827,42.407a6.3,6.3,0,0,1-2.247-6l1.6-9.091-2.133,1.55-6.7,9.227-5.1-3.706,7.409-10.2ZM31.25,14.105a6.3,6.3,0,1,1,4.457-1.846A6.3,6.3,0,0,1,31.25,14.105ZM21.885,55.642,11.756,67.712,6.929,63.662l9.378-11.174,2.351-6.87L24.3,50.345Z"
                transform="translate(-5.249 -1.5)"
                fill="#1a1a1a"
              />
              <text
                id="_3_mins._30_Sec."
                data-name="3 mins. 30 Sec."
                transform="translate(56.703 55.245)"
                fill="#1a1a1a"
                fontSize="46"
                fontFamily="SegoeUI-Bold, Segoe UI"
                fontWeight="700"
              >
                <tspan x="0" y="0">
                  3 Mins. 30 Sec.
                </tspan>
              </text>
            </g>
          </g>
        </g> */}

        <g
          className="path_info_popup"
          id="no_mad_bellagio_convention_center_tram_info"
          transform="translate(1500 -450)"
          opacity="0"
        >
          <path
            id="Path_8-35"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4598.578 5770.33) rotate(2)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-35"
            data-name="Rectangle 5"
            width="407.715"
            height="138.804"
            rx="28"
            transform="translate(4597 5650)"
            fill="#fff"
          />
          <path
            id="walking-30"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4612.804 5685.02)"
            fill="#1a1a1a"
          />
          <text
            id="_13_Mins._30_Sec."
            data-name="13 Mins. 30 Sec."
            transform="translate(4833.715 5736.459)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-167.346" y="0">
              13 Mins. 30 Sec.
            </tspan>
          </text>
        </g>

        <g
          className="path_info_popup"
          id="no_mad_to_vdara_raphael_walking_info"
          transform="translate(1300 -2010)"
          opacity="0"
        >
          <path
            id="Path_8-34"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4598.578 5770.33) rotate(2)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-34"
            data-name="Rectangle 5"
            width="407.715"
            height="138.804"
            rx="28"
            transform="translate(4597 5650)"
            fill="#fff"
          />
          <path
            id="walking-28"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4612.804 5685.02)"
            fill="#1a1a1a"
          />
          <text
            id="_12_Mins._30_Sec."
            data-name="12 Mins. 30 Sec."
            transform="translate(4833.715 5736.459)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-167.346" y="0">
              12 Mins. 30 Sec.
            </tspan>
          </text>
        </g>
        <g
          id="no_mad_to_vdara_raphael_tram_info"
          transform="translate(1648.085 -436.022)"
          opacity="0"
          className="path_info_popup"
        >
          <path
            id="Path_8-33"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4618.218 5739.329) rotate(3)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-33"
            data-name="Rectangle 5"
            width="342.915"
            height="109.309"
            rx="34"
            transform="translate(4615 5650)"
            fill="#fff"
          />
          <path
            id="Path_563-6"
            data-name="Path 563"
            d="M95.675,31.565,93.907,13.3a7.922,7.922,0,0,0-7.621-7.44H81.88V3.512h1.658a1.174,1.174,0,0,1,.985.557,1.536,1.536,0,0,0,2.2.369,1.849,1.849,0,0,0,.468-2.355A4.346,4.346,0,0,0,83.535,0H70.829a4.349,4.349,0,0,0-3.651,2.081,1.85,1.85,0,0,0,.414,2.442,1.542,1.542,0,0,0,2.252-.449,1.174,1.174,0,0,1,.985-.557h1.658V5.868H68.075a7.923,7.923,0,0,0-7.621,7.444L58.686,31.6a8.993,8.993,0,0,0,.218,3.008L60.672,41.8a8.016,8.016,0,0,0,5.389,5.874L64.239,53.3a1.8,1.8,0,0,0,.992,2.239A1.591,1.591,0,0,0,67.3,54.465l2.1-6.5H84.959l2.1,6.5a1.591,1.591,0,0,0,2.064,1.075,1.8,1.8,0,0,0,.992-2.239L88.3,47.67a8.018,8.018,0,0,0,5.389-5.885l1.768-7.218A8.974,8.974,0,0,0,95.675,31.565ZM75.722,3.512h2.915V5.863H75.722ZM72.227,40.625a.743.743,0,0,1-.711.771H66.425a.728.728,0,0,1-.7-.62l-.57-3.114a.819.819,0,0,1,.148-.64.69.69,0,0,1,.55-.281h5.658a.743.743,0,0,1,.711.771v3.114Zm16.979-2.963-.57,3.114a.731.731,0,0,1-.7.621H82.848a.743.743,0,0,1-.711-.771V37.508a.743.743,0,0,1,.711-.771h5.658a.691.691,0,0,1,.55.281.819.819,0,0,1,.148.64Zm-25.5-8.612L64.76,18.2a5.882,5.882,0,0,1,5.658-5.526H83.933A5.882,5.882,0,0,1,89.591,18.2l1.052,10.852H63.7Z"
            transform="translate(4597.048 5676.834)"
          />
          <text
            id="_12-19_Mins-2"
            data-name="12-19 Mins"
            transform="translate(4835.028 5720.474)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-112.681" y="0">
              12-19 Mins
            </tspan>
          </text>
        </g>
        <g
          className="path_info_popup"
          id="aria_w_convention_to_no_mad_walk_info"
          transform="translate(650 -1100)"
          opacity="0"
        >
          <path
            id="Path_8-33"
            data-name="Path 8"
            d="M0,0,25.053,45.227,50.106,0Z"
            transform="translate(4598.578 5770.33) rotate(2)"
            fill="#fff"
          />
          <rect
            id="Rectangle_5-33"
            data-name="Rectangle 5"
            width="407.715"
            height="138.804"
            rx="28"
            transform="translate(4597 5650)"
            fill="#fff"
          />
          <path
            id="walking-27"
            data-name="walking"
            d="M11.638,20.225l8.639-6.043a5.521,5.521,0,0,1,3.351-1,7.036,7.036,0,0,1,6.538,4.724,11.24,11.24,0,0,0,1.375,3.07,13.636,13.636,0,0,0,10.777,5.187v5.193a19.123,19.123,0,0,1-14.562-6.614L25.877,35.013,31.434,39.5l5.992,15.858L32.358,57.14l-5.5-14.55L17.719,35.2A5.094,5.094,0,0,1,15.8,30.26l1.359-7.491-1.826,1.277L9.6,31.637,5.249,28.6l6.337-8.4ZM27.5,11.887A5.345,5.345,0,0,1,22.2,7.712,5.155,5.155,0,0,1,25.422,1.9a5.508,5.508,0,0,1,6.548,1.91,5.05,5.05,0,0,1-.67,6.558,5.5,5.5,0,0,1-3.81,1.518ZM19.48,46.108l-8.658,9.946-4.13-3.337,8.016-9.208,2.011-5.661,4.829,3.895Z"
            transform="translate(4612.804 5685.02)"
            fill="#1a1a1a"
          />
          <text
            id="_8_Mins._30_Sec."
            data-name="8 Mins. 30 Sec."
            transform="translate(4833.715 5736.459)"
            fill="#030000"
            fontSize="47"
            fontFamily="SegoeUI-Semibold, Segoe UI"
            fontWeight="600"
          >
            <tspan x="-157.891" y="0">
              8 Mins. 30 Sec.
            </tspan>
          </text>
        </g>
      </g>
    </>
  );
}

export default memo(RoutePathElements);
